/**
 * Source: http://download.geonames.org/export/dump/countryInfo.txt
 */
export default {
    "AD": {
        "ISO3": "AND",
        "ISO-Numeric": 20,
        "fips": "AN",
        "Country": "Andorra",
        "Capital": "Andorra la Vella",
        "Area(in sq km)": 468,
        "Population": 84000,
        "Continent": "EU",
        "tld": ".ad",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 376,
        "Postal Code Format": "AD###",
        "Postal Code Regex": "^(?:AD)*(\\d{3})$",
        "Languages": "ca",
        "geonameid": 3041565,
        "neighbours": "ES,FR",
        "EquivalentFipsCode": ""
    },
    "AE": {
        "ISO3": "ARE",
        "ISO-Numeric": 784,
        "fips": "AE",
        "Country": "United Arab Emirates",
        "Capital": "Abu Dhabi",
        "Area(in sq km)": 82880,
        "Population": 4975593,
        "Continent": "AS",
        "tld": ".ae",
        "CurrencyCode": "AED",
        "CurrencyName": "Dirham",
        "Phone": 971,
        "Postal Code Format": "",
        "Postal C§ode Regex": "",
        "Languages": "ar-AE,fa,en,hi,ur",
        "geonameid": 290557,
        "neighbours": "SA,OM",
        "EquivalentFipsCode": ""
    },
    "AF": {
        "ISO3": "AFG",
        "ISO-Numeric": 4,
        "fips": "AF",
        "Country": "Afghanistan",
        "Capital": "Kabul",
        "Area(in sq km)": 647500,
        "Population": 29121286,
        "Continent": "AS",
        "tld": ".af",
        "CurrencyCode": "AFN",
        "CurrencyName": "Afghani",
        "Phone": 93,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fa-AF,ps,uz-AF,tk",
        "geonameid": 1149361,
        "neighbours": "TM,CN,IR,TJ,PK,UZ",
        "EquivalentFipsCode": ""
    },
    "AG": {
        "ISO3": "ATG",
        "ISO-Numeric": 28,
        "fips": "AC",
        "Country": "Antigua and Barbuda",
        "Capital": "St. John's",
        "Area(in sq km)": 443,
        "Population": 86754,
        "Continent": "NA",
        "tld": ".ag",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-268",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-AG",
        "geonameid": 3576396,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AI": {
        "ISO3": "AIA",
        "ISO-Numeric": 660,
        "fips": "AV",
        "Country": "Anguilla",
        "Capital": "The Valley",
        "Area(in sq km)": 102,
        "Population": 13254,
        "Continent": "NA",
        "tld": ".ai",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-264",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-AI",
        "geonameid": 3573511,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AL": {
        "ISO3": "ALB",
        "ISO-Numeric": 8,
        "fips": "AL",
        "Country": "Albania",
        "Capital": "Tirana",
        "Area(in sq km)": 28748,
        "Population": 2986952,
        "Continent": "EU",
        "tld": ".al",
        "CurrencyCode": "ALL",
        "CurrencyName": "Lek",
        "Phone": 355,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "sq,el",
        "geonameid": 783754,
        "neighbours": "MK,GR,ME,RS,XK",
        "EquivalentFipsCode": ""
    },
    "AM": {
        "ISO3": "ARM",
        "ISO-Numeric": 51,
        "fips": "AM",
        "Country": "Armenia",
        "Capital": "Yerevan",
        "Area(in sq km)": 29800,
        "Population": 2968000,
        "Continent": "AS",
        "tld": ".am",
        "CurrencyCode": "AMD",
        "CurrencyName": "Dram",
        "Phone": 374,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "hy",
        "geonameid": 174982,
        "neighbours": "GE,IR,AZ,TR",
        "EquivalentFipsCode": ""
    },
    "AO": {
        "ISO3": "AGO",
        "ISO-Numeric": 24,
        "fips": "AO",
        "Country": "Angola",
        "Capital": "Luanda",
        "Area(in sq km)": 1246700,
        "Population": 13068161,
        "Continent": "AF",
        "tld": ".ao",
        "CurrencyCode": "AOA",
        "CurrencyName": "Kwanza",
        "Phone": 244,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "pt-AO",
        "geonameid": 3351879,
        "neighbours": "CD,NA,ZM,CG",
        "EquivalentFipsCode": ""
    },
    "AQ": {
        "ISO3": "ATA",
        "ISO-Numeric": 10,
        "fips": "AY",
        "Country": "Antarctica",
        "Capital": "",
        "Area(in sq km)": 14000000,
        "Population": 0,
        "Continent": "AN",
        "tld": ".aq",
        "CurrencyCode": "",
        "CurrencyName": "",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "",
        "geonameid": 6697173,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AR": {
        "ISO3": "ARG",
        "ISO-Numeric": 32,
        "fips": "AR",
        "Country": "Argentina",
        "Capital": "Buenos Aires",
        "Area(in sq km)": 2766890,
        "Population": 41343201,
        "Continent": "SA",
        "tld": ".ar",
        "CurrencyCode": "ARS",
        "CurrencyName": "Peso",
        "Phone": 54,
        "Postal Code Format": "@####@@@",
        "Postal Code Regex": "^[A-Z]?\\d{4}[A-Z]{0,3}$",
        "Languages": "es-AR,en,it,de,fr,gn",
        "geonameid": 3865483,
        "neighbours": "CL,BO,UY,PY,BR",
        "EquivalentFipsCode": ""
    },
    "AS": {
        "ISO3": "ASM",
        "ISO-Numeric": 16,
        "fips": "AQ",
        "Country": "American Samoa",
        "Capital": "Pago Pago",
        "Area(in sq km)": 199,
        "Population": 57881,
        "Continent": "OC",
        "tld": ".as",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-684",
        "Postal Code Format": "#####-####",
        "Postal Code Regex": 96799,
        "Languages": "en-AS,sm,to",
        "geonameid": 5880801,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AT": {
        "ISO3": "AUT",
        "ISO-Numeric": 40,
        "fips": "AU",
        "Country": "Austria",
        "Capital": "Vienna",
        "Area(in sq km)": 83858,
        "Population": 8205000,
        "Continent": "EU",
        "tld": ".at",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 43,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "de-AT,hr,hu,sl",
        "geonameid": 2782113,
        "neighbours": "CH,DE,HU,SK,CZ,IT,SI,LI",
        "EquivalentFipsCode": ""
    },
    "AU": {
        "ISO3": "AUS",
        "ISO-Numeric": 36,
        "fips": "AS",
        "Country": "Australia",
        "Capital": "Canberra",
        "Area(in sq km)": 7686850,
        "Population": 21515754,
        "Continent": "OC",
        "tld": ".au",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 61,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "en-AU",
        "geonameid": 2077456,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AW": {
        "ISO3": "ABW",
        "ISO-Numeric": 533,
        "fips": "AA",
        "Country": "Aruba",
        "Capital": "Oranjestad",
        "Area(in sq km)": 193,
        "Population": 71566,
        "Continent": "NA",
        "tld": ".aw",
        "CurrencyCode": "AWG",
        "CurrencyName": "Guilder",
        "Phone": 297,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl-AW,es,en",
        "geonameid": 3577279,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "AX": {
        "ISO3": "ALA",
        "ISO-Numeric": 248,
        "fips": "",
        "Country": "Aland Islands",
        "Capital": "Mariehamn",
        "Area(in sq km)": 1580,
        "Population": 26711,
        "Continent": "EU",
        "tld": ".ax",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": "+358-18",
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(?:FI)*(\\d{5})$",
        "Languages": "sv-AX",
        "geonameid": 661882,
        "neighbours": "",
        "EquivalentFipsCode": "FI"
    },
    "AZ": {
        "ISO3": "AZE",
        "ISO-Numeric": 31,
        "fips": "AJ",
        "Country": "Azerbaijan",
        "Capital": "Baku",
        "Area(in sq km)": 86600,
        "Population": 8303512,
        "Continent": "AS",
        "tld": ".az",
        "CurrencyCode": "AZN",
        "CurrencyName": "Manat",
        "Phone": 994,
        "Postal Code Format": "AZ ####",
        "Postal Code Regex": "^(?:AZ)*(\\d{4})$",
        "Languages": "az,ru,hy",
        "geonameid": 587116,
        "neighbours": "GE,IR,AM,TR,RU",
        "EquivalentFipsCode": ""
    },
    "BA": {
        "ISO3": "BIH",
        "ISO-Numeric": 70,
        "fips": "BK",
        "Country": "Bosnia and Herzegovina",
        "Capital": "Sarajevo",
        "Area(in sq km)": 51129,
        "Population": 4590000,
        "Continent": "EU",
        "tld": ".ba",
        "CurrencyCode": "BAM",
        "CurrencyName": "Marka",
        "Phone": 387,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "bs,hr-BA,sr-BA",
        "geonameid": 3277605,
        "neighbours": "HR,ME,RS",
        "EquivalentFipsCode": ""
    },
    "BB": {
        "ISO3": "BRB",
        "ISO-Numeric": 52,
        "fips": "BB",
        "Country": "Barbados",
        "Capital": "Bridgetown",
        "Area(in sq km)": 431,
        "Population": 285653,
        "Continent": "NA",
        "tld": ".bb",
        "CurrencyCode": "BBD",
        "CurrencyName": "Dollar",
        "Phone": "+1-246",
        "Postal Code Format": "BB#####",
        "Postal Code Regex": "^(?:BB)*(\\d{5})$",
        "Languages": "en-BB",
        "geonameid": 3374084,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BD": {
        "ISO3": "BGD",
        "ISO-Numeric": 50,
        "fips": "BG",
        "Country": "Bangladesh",
        "Capital": "Dhaka",
        "Area(in sq km)": 144000,
        "Population": 156118464,
        "Continent": "AS",
        "tld": ".bd",
        "CurrencyCode": "BDT",
        "CurrencyName": "Taka",
        "Phone": 880,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "bn-BD,en",
        "geonameid": 1210997,
        "neighbours": "MM,IN",
        "EquivalentFipsCode": ""
    },
    "BE": {
        "ISO3": "BEL",
        "ISO-Numeric": 56,
        "fips": "BE",
        "Country": "Belgium",
        "Capital": "Brussels",
        "Area(in sq km)": 30510,
        "Population": 10403000,
        "Continent": "EU",
        "tld": ".be",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 32,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "nl-BE,fr-BE,de-BE",
        "geonameid": 2802361,
        "neighbours": "DE,NL,LU,FR",
        "EquivalentFipsCode": ""
    },
    "BF": {
        "ISO3": "BFA",
        "ISO-Numeric": 854,
        "fips": "UV",
        "Country": "Burkina Faso",
        "Capital": "Ouagadougou",
        "Area(in sq km)": 274200,
        "Population": 16241811,
        "Continent": "AF",
        "tld": ".bf",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 226,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-BF",
        "geonameid": 2361809,
        "neighbours": "NE,BJ,GH,CI,TG,ML",
        "EquivalentFipsCode": ""
    },
    "BG": {
        "ISO3": "BGR",
        "ISO-Numeric": 100,
        "fips": "BU",
        "Country": "Bulgaria",
        "Capital": "Sofia",
        "Area(in sq km)": 110910,
        "Population": 7148785,
        "Continent": "EU",
        "tld": ".bg",
        "CurrencyCode": "BGN",
        "CurrencyName": "Lev",
        "Phone": 359,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "bg,tr-BG,rom",
        "geonameid": 732800,
        "neighbours": "MK,GR,RO,TR,RS",
        "EquivalentFipsCode": ""
    },
    "BH": {
        "ISO3": "BHR",
        "ISO-Numeric": 48,
        "fips": "BA",
        "Country": "Bahrain",
        "Capital": "Manama",
        "Area(in sq km)": 665,
        "Population": 738004,
        "Continent": "AS",
        "tld": ".bh",
        "CurrencyCode": "BHD",
        "CurrencyName": "Dinar",
        "Phone": 973,
        "Postal Code Format": "####|###",
        "Postal Code Regex": "^(\\d{3}\\d?)$",
        "Languages": "ar-BH,en,fa,ur",
        "geonameid": 290291,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BI": {
        "ISO3": "BDI",
        "ISO-Numeric": 108,
        "fips": "BY",
        "Country": "Burundi",
        "Capital": "Bujumbura",
        "Area(in sq km)": 27830,
        "Population": 9863117,
        "Continent": "AF",
        "tld": ".bi",
        "CurrencyCode": "BIF",
        "CurrencyName": "Franc",
        "Phone": 257,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-BI,rn",
        "geonameid": 433561,
        "neighbours": "TZ,CD,RW",
        "EquivalentFipsCode": ""
    },
    "BJ": {
        "ISO3": "BEN",
        "ISO-Numeric": 204,
        "fips": "BN",
        "Country": "Benin",
        "Capital": "Porto-Novo",
        "Area(in sq km)": 112620,
        "Population": 9056010,
        "Continent": "AF",
        "tld": ".bj",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 229,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-BJ",
        "geonameid": 2395170,
        "neighbours": "NE,TG,BF,NG",
        "EquivalentFipsCode": ""
    },
    "BL": {
        "ISO3": "BLM",
        "ISO-Numeric": 652,
        "fips": "TB",
        "Country": "Saint Barthelemy",
        "Capital": "Gustavia",
        "Area(in sq km)": 21,
        "Population": 8450,
        "Continent": "NA",
        "tld": ".gp",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 590,
        "Postal Code Format": "### ###",
        "Postal Code Regex": "",
        "Languages": "fr",
        "geonameid": 3578476,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BM": {
        "ISO3": "BMU",
        "ISO-Numeric": 60,
        "fips": "BD",
        "Country": "Bermuda",
        "Capital": "Hamilton",
        "Area(in sq km)": 53,
        "Population": 65365,
        "Continent": "NA",
        "tld": ".bm",
        "CurrencyCode": "BMD",
        "CurrencyName": "Dollar",
        "Phone": "+1-441",
        "Postal Code Format": "@@ ##",
        "Postal Code Regex": "^([A-Z]{2}\\d{2})$",
        "Languages": "en-BM,pt",
        "geonameid": 3573345,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BN": {
        "ISO3": "BRN",
        "ISO-Numeric": 96,
        "fips": "BX",
        "Country": "Brunei",
        "Capital": "Bandar Seri Begawan",
        "Area(in sq km)": 5770,
        "Population": 395027,
        "Continent": "AS",
        "tld": ".bn",
        "CurrencyCode": "BND",
        "CurrencyName": "Dollar",
        "Phone": 673,
        "Postal Code Format": "@@####",
        "Postal Code Regex": "^([A-Z]{2}\\d{4})$",
        "Languages": "ms-BN,en-BN",
        "geonameid": 1820814,
        "neighbours": "MY",
        "EquivalentFipsCode": ""
    },
    "BO": {
        "ISO3": "BOL",
        "ISO-Numeric": 68,
        "fips": "BL",
        "Country": "Bolivia",
        "Capital": "Sucre",
        "Area(in sq km)": 1098580,
        "Population": 9947418,
        "Continent": "SA",
        "tld": ".bo",
        "CurrencyCode": "BOB",
        "CurrencyName": "Boliviano",
        "Phone": 591,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "es-BO,qu,ay",
        "geonameid": 3923057,
        "neighbours": "PE,CL,PY,BR,AR",
        "EquivalentFipsCode": ""
    },
    "BQ": {
        "ISO3": "BES",
        "ISO-Numeric": 535,
        "fips": "",
        "Country": "Bonaire, Saint Eustatius and Saba",
        "Capital": "",
        "Area(in sq km)": 328,
        "Population": 18012,
        "Continent": "NA",
        "tld": ".bq",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 599,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl,pap,en",
        "geonameid": 7626844,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BR": {
        "ISO3": "BRA",
        "ISO-Numeric": 76,
        "fips": "BR",
        "Country": "Brazil",
        "Capital": "Brasilia",
        "Area(in sq km)": 8511965,
        "Population": 201103330,
        "Continent": "SA",
        "tld": ".br",
        "CurrencyCode": "BRL",
        "CurrencyName": "Real",
        "Phone": 55,
        "Postal Code Format": "#####-###",
        "Postal Code Regex": "^\\d{5}-\\d{3}$",
        "Languages": "pt-BR,es,en,fr",
        "geonameid": 3469034,
        "neighbours": "SR,PE,BO,UY,GY,PY,GF,VE,CO,AR",
        "EquivalentFipsCode": ""
    },
    "BS": {
        "ISO3": "BHS",
        "ISO-Numeric": 44,
        "fips": "BF",
        "Country": "Bahamas",
        "Capital": "Nassau",
        "Area(in sq km)": 13940,
        "Population": 301790,
        "Continent": "NA",
        "tld": ".bs",
        "CurrencyCode": "BSD",
        "CurrencyName": "Dollar",
        "Phone": "+1-242",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-BS",
        "geonameid": 3572887,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BT": {
        "ISO3": "BTN",
        "ISO-Numeric": 64,
        "fips": "BT",
        "Country": "Bhutan",
        "Capital": "Thimphu",
        "Area(in sq km)": 47000,
        "Population": 699847,
        "Continent": "AS",
        "tld": ".bt",
        "CurrencyCode": "BTN",
        "CurrencyName": "Ngultrum",
        "Phone": 975,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "dz",
        "geonameid": 1252634,
        "neighbours": "CN,IN",
        "EquivalentFipsCode": ""
    },
    "BV": {
        "ISO3": "BVT",
        "ISO-Numeric": 74,
        "fips": "BV",
        "Country": "Bouvet Island",
        "Capital": "",
        "Area(in sq km)": 49,
        "Population": 0,
        "Continent": "AN",
        "tld": ".bv",
        "CurrencyCode": "NOK",
        "CurrencyName": "Krone",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "",
        "geonameid": 3371123,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "BW": {
        "ISO3": "BWA",
        "ISO-Numeric": 72,
        "fips": "BC",
        "Country": "Botswana",
        "Capital": "Gaborone",
        "Area(in sq km)": 600370,
        "Population": 2029307,
        "Continent": "AF",
        "tld": ".bw",
        "CurrencyCode": "BWP",
        "CurrencyName": "Pula",
        "Phone": 267,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-BW,tn-BW",
        "geonameid": 933860,
        "neighbours": "ZW,ZA,NA",
        "EquivalentFipsCode": ""
    },
    "BY": {
        "ISO3": "BLR",
        "ISO-Numeric": 112,
        "fips": "BO",
        "Country": "Belarus",
        "Capital": "Minsk",
        "Area(in sq km)": 207600,
        "Population": 9685000,
        "Continent": "EU",
        "tld": ".by",
        "CurrencyCode": "BYR",
        "CurrencyName": "Ruble",
        "Phone": 375,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "be,ru",
        "geonameid": 630336,
        "neighbours": "PL,LT,UA,RU,LV",
        "EquivalentFipsCode": ""
    },
    "BZ": {
        "ISO3": "BLZ",
        "ISO-Numeric": 84,
        "fips": "BH",
        "Country": "Belize",
        "Capital": "Belmopan",
        "Area(in sq km)": 22966,
        "Population": 314522,
        "Continent": "NA",
        "tld": ".bz",
        "CurrencyCode": "BZD",
        "CurrencyName": "Dollar",
        "Phone": 501,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-BZ,es",
        "geonameid": 3582678,
        "neighbours": "GT,MX",
        "EquivalentFipsCode": ""
    },
    "CA": {
        "ISO3": "CAN",
        "ISO-Numeric": 124,
        "fips": "CA",
        "Country": "Canada",
        "Capital": "Ottawa",
        "Area(in sq km)": 9984670,
        "Population": 33679000,
        "Continent": "NA",
        "tld": ".ca",
        "CurrencyCode": "CAD",
        "CurrencyName": "Dollar",
        "Phone": 1,
        "Postal Code Format": "@#@ #@#",
        "Postal Code Regex": "^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$",
        "Languages": "en-CA,fr-CA,iu",
        "geonameid": 6251999,
        "neighbours": "US",
        "EquivalentFipsCode": ""
    },
    "CC": {
        "ISO3": "CCK",
        "ISO-Numeric": 166,
        "fips": "CK",
        "Country": "Cocos Islands",
        "Capital": "West Island",
        "Area(in sq km)": 14,
        "Population": 628,
        "Continent": "AS",
        "tld": ".cc",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 61,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ms-CC,en",
        "geonameid": 1547376,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CD": {
        "ISO3": "COD",
        "ISO-Numeric": 180,
        "fips": "CG",
        "Country": "Democratic Republic of the Congo",
        "Capital": "Kinshasa",
        "Area(in sq km)": 2345410,
        "Population": 70916439,
        "Continent": "AF",
        "tld": ".cd",
        "CurrencyCode": "CDF",
        "CurrencyName": "Franc",
        "Phone": 243,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-CD,ln,kg",
        "geonameid": 203312,
        "neighbours": "TZ,CF,SS,RW,ZM,BI,UG,CG,AO",
        "EquivalentFipsCode": ""
    },
    "CF": {
        "ISO3": "CAF",
        "ISO-Numeric": 140,
        "fips": "CT",
        "Country": "Central African Republic",
        "Capital": "Bangui",
        "Area(in sq km)": 622984,
        "Population": 4844927,
        "Continent": "AF",
        "tld": ".cf",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 236,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-CF,sg,ln,kg",
        "geonameid": 239880,
        "neighbours": "TD,SD,CD,SS,CM,CG",
        "EquivalentFipsCode": ""
    },
    "CG": {
        "ISO3": "COG",
        "ISO-Numeric": 178,
        "fips": "CF",
        "Country": "Republic of the Congo",
        "Capital": "Brazzaville",
        "Area(in sq km)": 342000,
        "Population": 3039126,
        "Continent": "AF",
        "tld": ".cg",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 242,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-CG,kg,ln-CG",
        "geonameid": 2260494,
        "neighbours": "CF,GA,CD,CM,AO",
        "EquivalentFipsCode": ""
    },
    "CH": {
        "ISO3": "CHE",
        "ISO-Numeric": 756,
        "fips": "SZ",
        "Country": "Switzerland",
        "Capital": "Bern",
        "Area(in sq km)": 41290,
        "Population": 7581000,
        "Continent": "EU",
        "tld": ".ch",
        "CurrencyCode": "CHF",
        "CurrencyName": "Franc",
        "Phone": 41,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "de-CH,fr-CH,it-CH,rm",
        "geonameid": 2658434,
        "neighbours": "DE,IT,LI,FR,AT",
        "EquivalentFipsCode": ""
    },
    "CI": {
        "ISO3": "CIV",
        "ISO-Numeric": 384,
        "fips": "IV",
        "Country": "Ivory Coast",
        "Capital": "Yamoussoukro",
        "Area(in sq km)": 322460,
        "Population": 21058798,
        "Continent": "AF",
        "tld": ".ci",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 225,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-CI",
        "geonameid": 2287781,
        "neighbours": "LR,GH,GN,BF,ML",
        "EquivalentFipsCode": ""
    },
    "CK": {
        "ISO3": "COK",
        "ISO-Numeric": 184,
        "fips": "CW",
        "Country": "Cook Islands",
        "Capital": "Avarua",
        "Area(in sq km)": 240,
        "Population": 21388,
        "Continent": "OC",
        "tld": ".ck",
        "CurrencyCode": "NZD",
        "CurrencyName": "Dollar",
        "Phone": 682,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-CK,mi",
        "geonameid": 1899402,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CL": {
        "ISO3": "CHL",
        "ISO-Numeric": 152,
        "fips": "CI",
        "Country": "Chile",
        "Capital": "Santiago",
        "Area(in sq km)": 756950,
        "Population": 16746491,
        "Continent": "SA",
        "tld": ".cl",
        "CurrencyCode": "CLP",
        "CurrencyName": "Peso",
        "Phone": 56,
        "Postal Code Format": "#######",
        "Postal Code Regex": "^(\\d{7})$",
        "Languages": "es-CL",
        "geonameid": 3895114,
        "neighbours": "PE,BO,AR",
        "EquivalentFipsCode": ""
    },
    "CM": {
        "ISO3": "CMR",
        "ISO-Numeric": 120,
        "fips": "CM",
        "Country": "Cameroon",
        "Capital": "Yaounde",
        "Area(in sq km)": 475440,
        "Population": 19294149,
        "Continent": "AF",
        "tld": ".cm",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 237,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-CM,fr-CM",
        "geonameid": 2233387,
        "neighbours": "TD,CF,GA,GQ,CG,NG",
        "EquivalentFipsCode": ""
    },
    "CN": {
        "ISO3": "CHN",
        "ISO-Numeric": 156,
        "fips": "CH",
        "Country": "China",
        "Capital": "Beijing",
        "Area(in sq km)": 9596960,
        "Population": 1330044000,
        "Continent": "AS",
        "tld": ".cn",
        "CurrencyCode": "CNY",
        "CurrencyName": "Yuan Renminbi",
        "Phone": 86,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "zh-CN,yue,wuu,dta,ug,za",
        "geonameid": 1814991,
        "neighbours": "LA,BT,TJ,KZ,MN,AF,NP,MM,KG,PK,KP,RU,VN,IN",
        "EquivalentFipsCode": ""
    },
    "CO": {
        "ISO3": "COL",
        "ISO-Numeric": 170,
        "fips": "CO",
        "Country": "Colombia",
        "Capital": "Bogota",
        "Area(in sq km)": 1138910,
        "Population": 47790000,
        "Continent": "SA",
        "tld": ".co",
        "CurrencyCode": "COP",
        "CurrencyName": "Peso",
        "Phone": 57,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "es-CO",
        "geonameid": 3686110,
        "neighbours": "EC,PE,PA,BR,VE",
        "EquivalentFipsCode": ""
    },
    "CR": {
        "ISO3": "CRI",
        "ISO-Numeric": 188,
        "fips": "CS",
        "Country": "Costa Rica",
        "Capital": "San Jose",
        "Area(in sq km)": 51100,
        "Population": 4516220,
        "Continent": "NA",
        "tld": ".cr",
        "CurrencyCode": "CRC",
        "CurrencyName": "Colon",
        "Phone": 506,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-CR,en",
        "geonameid": 3624060,
        "neighbours": "PA,NI",
        "EquivalentFipsCode": ""
    },
    "CU": {
        "ISO3": "CUB",
        "ISO-Numeric": 192,
        "fips": "CU",
        "Country": "Cuba",
        "Capital": "Havana",
        "Area(in sq km)": 110860,
        "Population": 11423000,
        "Continent": "NA",
        "tld": ".cu",
        "CurrencyCode": "CUP",
        "CurrencyName": "Peso",
        "Phone": 53,
        "Postal Code Format": "CP #####",
        "Postal Code Regex": "^(?:CP)*(\\d{5})$",
        "Languages": "es-CU",
        "geonameid": 3562981,
        "neighbours": "US",
        "EquivalentFipsCode": ""
    },
    "CV": {
        "ISO3": "CPV",
        "ISO-Numeric": 132,
        "fips": "CV",
        "Country": "Cape Verde",
        "Capital": "Praia",
        "Area(in sq km)": 4033,
        "Population": 508659,
        "Continent": "AF",
        "tld": ".cv",
        "CurrencyCode": "CVE",
        "CurrencyName": "Escudo",
        "Phone": 238,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "pt-CV",
        "geonameid": 3374766,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CW": {
        "ISO3": "CUW",
        "ISO-Numeric": 531,
        "fips": "UC",
        "Country": "Curacao",
        "Capital": "Willemstad",
        "Area(in sq km)": 444,
        "Population": 141766,
        "Continent": "NA",
        "tld": ".cw",
        "CurrencyCode": "ANG",
        "CurrencyName": "Guilder",
        "Phone": 599,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl,pap",
        "geonameid": 7626836,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CX": {
        "ISO3": "CXR",
        "ISO-Numeric": 162,
        "fips": "KT",
        "Country": "Christmas Island",
        "Capital": "Flying Fish Cove",
        "Area(in sq km)": 135,
        "Population": 1500,
        "Continent": "AS",
        "tld": ".cx",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 61,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "en,zh,ms-CC",
        "geonameid": 2078138,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CY": {
        "ISO3": "CYP",
        "ISO-Numeric": 196,
        "fips": "CY",
        "Country": "Cyprus",
        "Capital": "Nicosia",
        "Area(in sq km)": 9250,
        "Population": 1102677,
        "Continent": "EU",
        "tld": ".cy",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 357,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "el-CY,tr-CY,en",
        "geonameid": 146669,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "CZ": {
        "ISO3": "CZE",
        "ISO-Numeric": 203,
        "fips": "EZ",
        "Country": "Czechia",
        "Capital": "Prague",
        "Area(in sq km)": 78866,
        "Population": 10476000,
        "Continent": "EU",
        "tld": ".cz",
        "CurrencyCode": "CZK",
        "CurrencyName": "Koruna",
        "Phone": 420,
        "Postal Code Format": "### ##",
        "Postal Code Regex": "^\\d{3}\\s?\\d{2}$",
        "Languages": "cs,sk",
        "geonameid": 3077311,
        "neighbours": "PL,DE,SK,AT",
        "EquivalentFipsCode": ""
    },
    "DE": {
        "ISO3": "DEU",
        "ISO-Numeric": 276,
        "fips": "GM",
        "Country": "Germany",
        "Capital": "Berlin",
        "Area(in sq km)": 357021,
        "Population": 81802257,
        "Continent": "EU",
        "tld": ".de",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 49,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "de",
        "geonameid": 2921044,
        "neighbours": "CH,PL,NL,DK,BE,CZ,LU,FR,AT",
        "EquivalentFipsCode": ""
    },
    "DJ": {
        "ISO3": "DJI",
        "ISO-Numeric": 262,
        "fips": "DJ",
        "Country": "Djibouti",
        "Capital": "Djibouti",
        "Area(in sq km)": 23000,
        "Population": 740528,
        "Continent": "AF",
        "tld": ".dj",
        "CurrencyCode": "DJF",
        "CurrencyName": "Franc",
        "Phone": 253,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-DJ,ar,so-DJ,aa",
        "geonameid": 223816,
        "neighbours": "ER,ET,SO",
        "EquivalentFipsCode": ""
    },
    "DK": {
        "ISO3": "DNK",
        "ISO-Numeric": 208,
        "fips": "DA",
        "Country": "Denmark",
        "Capital": "Copenhagen",
        "Area(in sq km)": 43094,
        "Population": 5484000,
        "Continent": "EU",
        "tld": ".dk",
        "CurrencyCode": "DKK",
        "CurrencyName": "Krone",
        "Phone": 45,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "da-DK,en,fo,de-DK",
        "geonameid": 2623032,
        "neighbours": "DE",
        "EquivalentFipsCode": ""
    },
    "DM": {
        "ISO3": "DMA",
        "ISO-Numeric": 212,
        "fips": "DO",
        "Country": "Dominica",
        "Capital": "Roseau",
        "Area(in sq km)": 754,
        "Population": 72813,
        "Continent": "NA",
        "tld": ".dm",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-767",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-DM",
        "geonameid": 3575830,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "DO": {
        "ISO3": "DOM",
        "ISO-Numeric": 214,
        "fips": "DR",
        "Country": "Dominican Republic",
        "Capital": "Santo Domingo",
        "Area(in sq km)": 48730,
        "Population": 9823821,
        "Continent": "NA",
        "tld": ".do",
        "CurrencyCode": "DOP",
        "CurrencyName": "Peso",
        "Phone": "+1-809 and 1-829",
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-DO",
        "geonameid": 3508796,
        "neighbours": "HT",
        "EquivalentFipsCode": ""
    },
    "DZ": {
        "ISO3": "DZA",
        "ISO-Numeric": 12,
        "fips": "AG",
        "Country": "Algeria",
        "Capital": "Algiers",
        "Area(in sq km)": 2381740,
        "Population": 34586184,
        "Continent": "AF",
        "tld": ".dz",
        "CurrencyCode": "DZD",
        "CurrencyName": "Dinar",
        "Phone": 213,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-DZ",
        "geonameid": 2589581,
        "neighbours": "NE,EH,LY,MR,TN,MA,ML",
        "EquivalentFipsCode": ""
    },
    "EC": {
        "ISO3": "ECU",
        "ISO-Numeric": 218,
        "fips": "EC",
        "Country": "Ecuador",
        "Capital": "Quito",
        "Area(in sq km)": 283560,
        "Population": 14790608,
        "Continent": "SA",
        "tld": ".ec",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 593,
        "Postal Code Format": "@####@",
        "Postal Code Regex": "^([a-zA-Z]\\d{4}[a-zA-Z])$",
        "Languages": "es-EC",
        "geonameid": 3658394,
        "neighbours": "PE,CO",
        "EquivalentFipsCode": ""
    },
    "EE": {
        "ISO3": "EST",
        "ISO-Numeric": 233,
        "fips": "EN",
        "Country": "Estonia",
        "Capital": "Tallinn",
        "Area(in sq km)": 45226,
        "Population": 1291170,
        "Continent": "EU",
        "tld": ".ee",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 372,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "et,ru",
        "geonameid": 453733,
        "neighbours": "RU,LV",
        "EquivalentFipsCode": ""
    },
    "EG": {
        "ISO3": "EGY",
        "ISO-Numeric": 818,
        "fips": "EG",
        "Country": "Egypt",
        "Capital": "Cairo",
        "Area(in sq km)": 1001450,
        "Population": 80471869,
        "Continent": "AF",
        "tld": ".eg",
        "CurrencyCode": "EGP",
        "CurrencyName": "Pound",
        "Phone": 20,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-EG,en,fr",
        "geonameid": 357994,
        "neighbours": "LY,SD,IL,PS",
        "EquivalentFipsCode": ""
    },
    "EH": {
        "ISO3": "ESH",
        "ISO-Numeric": 732,
        "fips": "WI",
        "Country": "Western Sahara",
        "Capital": "El-Aaiun",
        "Area(in sq km)": 266000,
        "Population": 273008,
        "Continent": "AF",
        "tld": ".eh",
        "CurrencyCode": "MAD",
        "CurrencyName": "Dirham",
        "Phone": 212,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar,mey",
        "geonameid": 2461445,
        "neighbours": "DZ,MR,MA",
        "EquivalentFipsCode": ""
    },
    "ER": {
        "ISO3": "ERI",
        "ISO-Numeric": 232,
        "fips": "ER",
        "Country": "Eritrea",
        "Capital": "Asmara",
        "Area(in sq km)": 121320,
        "Population": 5792984,
        "Continent": "AF",
        "tld": ".er",
        "CurrencyCode": "ERN",
        "CurrencyName": "Nakfa",
        "Phone": 291,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "aa-ER,ar,tig,kun,ti-ER",
        "geonameid": 338010,
        "neighbours": "ET,SD,DJ",
        "EquivalentFipsCode": ""
    },
    "ES": {
        "ISO3": "ESP",
        "ISO-Numeric": 724,
        "fips": "SP",
        "Country": "Spain",
        "Capital": "Madrid",
        "Area(in sq km)": 504782,
        "Population": 46505963,
        "Continent": "EU",
        "tld": ".es",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 34,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-ES,ca,gl,eu,oc",
        "geonameid": 2510769,
        "neighbours": "AD,PT,GI,FR,MA",
        "EquivalentFipsCode": ""
    },
    "ET": {
        "ISO3": "ETH",
        "ISO-Numeric": 231,
        "fips": "ET",
        "Country": "Ethiopia",
        "Capital": "Addis Ababa",
        "Area(in sq km)": 1127127,
        "Population": 88013491,
        "Continent": "AF",
        "tld": ".et",
        "CurrencyCode": "ETB",
        "CurrencyName": "Birr",
        "Phone": 251,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "am,en-ET,om-ET,ti-ET,so-ET,sid",
        "geonameid": 337996,
        "neighbours": "ER,KE,SD,SS,SO,DJ",
        "EquivalentFipsCode": ""
    },
    "FI": {
        "ISO3": "FIN",
        "ISO-Numeric": 246,
        "fips": "FI",
        "Country": "Finland",
        "Capital": "Helsinki",
        "Area(in sq km)": 337030,
        "Population": 5244000,
        "Continent": "EU",
        "tld": ".fi",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 358,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(?:FI)*(\\d{5})$",
        "Languages": "fi-FI,sv-FI,smn",
        "geonameid": 660013,
        "neighbours": "NO,RU,SE",
        "EquivalentFipsCode": ""
    },
    "FJ": {
        "ISO3": "FJI",
        "ISO-Numeric": 242,
        "fips": "FJ",
        "Country": "Fiji",
        "Capital": "Suva",
        "Area(in sq km)": 18270,
        "Population": 875983,
        "Continent": "OC",
        "tld": ".fj",
        "CurrencyCode": "FJD",
        "CurrencyName": "Dollar",
        "Phone": 679,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-FJ,fj",
        "geonameid": 2205218,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "FK": {
        "ISO3": "FLK",
        "ISO-Numeric": 238,
        "fips": "FK",
        "Country": "Falkland Islands",
        "Capital": "Stanley",
        "Area(in sq km)": 12173,
        "Population": 2638,
        "Continent": "SA",
        "tld": ".fk",
        "CurrencyCode": "FKP",
        "CurrencyName": "Pound",
        "Phone": 500,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-FK",
        "geonameid": 3474414,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "FM": {
        "ISO3": "FSM",
        "ISO-Numeric": 583,
        "fips": "FM",
        "Country": "Micronesia",
        "Capital": "Palikir",
        "Area(in sq km)": 702,
        "Population": 107708,
        "Continent": "OC",
        "tld": ".fm",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 691,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "en-FM,chk,pon,yap,kos,uli,woe,nkr,kpg",
        "geonameid": 2081918,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "FO": {
        "ISO3": "FRO",
        "ISO-Numeric": 234,
        "fips": "FO",
        "Country": "Faroe Islands",
        "Capital": "Torshavn",
        "Area(in sq km)": 1399,
        "Population": 48228,
        "Continent": "EU",
        "tld": ".fo",
        "CurrencyCode": "DKK",
        "CurrencyName": "Krone",
        "Phone": 298,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(?:FO)*(\\d{3})$",
        "Languages": "fo,da-FO",
        "geonameid": 2622320,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "FR": {
        "ISO3": "FRA",
        "ISO-Numeric": 250,
        "fips": "FR",
        "Country": "France",
        "Capital": "Paris",
        "Area(in sq km)": 547030,
        "Population": 64768389,
        "Continent": "EU",
        "tld": ".fr",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 33,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-FR,frp,br,co,ca,eu,oc",
        "geonameid": 3017382,
        "neighbours": "CH,DE,BE,LU,IT,AD,MC,ES",
        "EquivalentFipsCode": ""
    },
    "GA": {
        "ISO3": "GAB",
        "ISO-Numeric": 266,
        "fips": "GB",
        "Country": "Gabon",
        "Capital": "Libreville",
        "Area(in sq km)": 267667,
        "Population": 1545255,
        "Continent": "AF",
        "tld": ".ga",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 241,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-GA",
        "geonameid": 2400553,
        "neighbours": "CM,GQ,CG",
        "EquivalentFipsCode": ""
    },
    "GB": {
        "ISO3": "GBR",
        "ISO-Numeric": 826,
        "fips": "UK",
        "Country": "United Kingdom",
        "Capital": "London",
        "Area(in sq km)": 244820,
        "Population": 62348447,
        "Continent": "EU",
        "tld": ".uk",
        "CurrencyCode": "GBP",
        "CurrencyName": "Pound",
        "Phone": 44,
        "Postal Code Format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
        "Postal Code Regex": "^((?:(?:[A-PR-UWYZ][A-HK-Y]\\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\\d[A-HJKPS-UW0-9])\\s\\d[ABD-HJLNP-UW-Z]{2})|GIR\\s?0AA)$",
        "Languages": "en-GB,cy-GB,gd",
        "geonameid": 2635167,
        "neighbours": "IE",
        "EquivalentFipsCode": ""
    },
    "GD": {
        "ISO3": "GRD",
        "ISO-Numeric": 308,
        "fips": "GJ",
        "Country": "Grenada",
        "Capital": "St. George's",
        "Area(in sq km)": 344,
        "Population": 107818,
        "Continent": "NA",
        "tld": ".gd",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-473",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-GD",
        "geonameid": 3580239,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GE": {
        "ISO3": "GEO",
        "ISO-Numeric": 268,
        "fips": "GG",
        "Country": "Georgia",
        "Capital": "Tbilisi",
        "Area(in sq km)": 69700,
        "Population": 4630000,
        "Continent": "AS",
        "tld": ".ge",
        "CurrencyCode": "GEL",
        "CurrencyName": "Lari",
        "Phone": 995,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "ka,ru,hy,az",
        "geonameid": 614540,
        "neighbours": "AM,AZ,TR,RU",
        "EquivalentFipsCode": ""
    },
    "GF": {
        "ISO3": "GUF",
        "ISO-Numeric": 254,
        "fips": "FG",
        "Country": "French Guiana",
        "Capital": "Cayenne",
        "Area(in sq km)": 91000,
        "Population": 195506,
        "Continent": "SA",
        "tld": ".gf",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 594,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^((97|98)3\\d{2})$",
        "Languages": "fr-GF",
        "geonameid": 3381670,
        "neighbours": "SR,BR",
        "EquivalentFipsCode": ""
    },
    "GG": {
        "ISO3": "GGY",
        "ISO-Numeric": 831,
        "fips": "GK",
        "Country": "Guernsey",
        "Capital": "St Peter Port",
        "Area(in sq km)": 78,
        "Population": 65228,
        "Continent": "EU",
        "tld": ".gg",
        "CurrencyCode": "GBP",
        "CurrencyName": "Pound",
        "Phone": "+44-1481",
        "Postal Code Format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
        "Postal Code Regex": "^((?:(?:[A-PR-UWYZ][A-HK-Y]\\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\\d[A-HJKPS-UW0-9])\\s\\d[ABD-HJLNP-UW-Z]{2})|GIR\\s?0AA)$",
        "Languages": "en,fr",
        "geonameid": 3042362,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GH": {
        "ISO3": "GHA",
        "ISO-Numeric": 288,
        "fips": "GH",
        "Country": "Ghana",
        "Capital": "Accra",
        "Area(in sq km)": 239460,
        "Population": 24339838,
        "Continent": "AF",
        "tld": ".gh",
        "CurrencyCode": "GHS",
        "CurrencyName": "Cedi",
        "Phone": 233,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-GH,ak,ee,tw",
        "geonameid": 2300660,
        "neighbours": "CI,TG,BF",
        "EquivalentFipsCode": ""
    },
    "GI": {
        "ISO3": "GIB",
        "ISO-Numeric": 292,
        "fips": "GI",
        "Country": "Gibraltar",
        "Capital": "Gibraltar",
        "Area(in sq km)": 6.5,
        "Population": 27884,
        "Continent": "EU",
        "tld": ".gi",
        "CurrencyCode": "GIP",
        "CurrencyName": "Pound",
        "Phone": 350,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-GI,es,it,pt",
        "geonameid": 2411586,
        "neighbours": "ES",
        "EquivalentFipsCode": ""
    },
    "GL": {
        "ISO3": "GRL",
        "ISO-Numeric": 304,
        "fips": "GL",
        "Country": "Greenland",
        "Capital": "Nuuk",
        "Area(in sq km)": 2166086,
        "Population": 56375,
        "Continent": "NA",
        "tld": ".gl",
        "CurrencyCode": "DKK",
        "CurrencyName": "Krone",
        "Phone": 299,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "kl,da-GL,en",
        "geonameid": 3425505,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GM": {
        "ISO3": "GMB",
        "ISO-Numeric": 270,
        "fips": "GA",
        "Country": "Gambia",
        "Capital": "Banjul",
        "Area(in sq km)": 11300,
        "Population": 1593256,
        "Continent": "AF",
        "tld": ".gm",
        "CurrencyCode": "GMD",
        "CurrencyName": "Dalasi",
        "Phone": 220,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-GM,mnk,wof,wo,ff",
        "geonameid": 2413451,
        "neighbours": "SN",
        "EquivalentFipsCode": ""
    },
    "GN": {
        "ISO3": "GIN",
        "ISO-Numeric": 324,
        "fips": "GV",
        "Country": "Guinea",
        "Capital": "Conakry",
        "Area(in sq km)": 245857,
        "Population": 10324025,
        "Continent": "AF",
        "tld": ".gn",
        "CurrencyCode": "GNF",
        "CurrencyName": "Franc",
        "Phone": 224,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-GN",
        "geonameid": 2420477,
        "neighbours": "LR,SN,SL,CI,GW,ML",
        "EquivalentFipsCode": ""
    },
    "GP": {
        "ISO3": "GLP",
        "ISO-Numeric": 312,
        "fips": "GP",
        "Country": "Guadeloupe",
        "Capital": "Basse-Terre",
        "Area(in sq km)": 1780,
        "Population": 443000,
        "Continent": "NA",
        "tld": ".gp",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 590,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^((97|98)\\d{3})$",
        "Languages": "fr-GP",
        "geonameid": 3579143,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GQ": {
        "ISO3": "GNQ",
        "ISO-Numeric": 226,
        "fips": "EK",
        "Country": "Equatorial Guinea",
        "Capital": "Malabo",
        "Area(in sq km)": 28051,
        "Population": 1014999,
        "Continent": "AF",
        "tld": ".gq",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 240,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "es-GQ,fr",
        "geonameid": 2309096,
        "neighbours": "GA,CM",
        "EquivalentFipsCode": ""
    },
    "GR": {
        "ISO3": "GRC",
        "ISO-Numeric": 300,
        "fips": "GR",
        "Country": "Greece",
        "Capital": "Athens",
        "Area(in sq km)": 131940,
        "Population": 11000000,
        "Continent": "EU",
        "tld": ".gr",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 30,
        "Postal Code Format": "### ##",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "el-GR,en,fr",
        "geonameid": 390903,
        "neighbours": "AL,MK,TR,BG",
        "EquivalentFipsCode": ""
    },
    "GS": {
        "ISO3": "SGS",
        "ISO-Numeric": 239,
        "fips": "SX",
        "Country": "South Georgia and the South Sandwich Islands",
        "Capital": "Grytviken",
        "Area(in sq km)": 3903,
        "Population": 30,
        "Continent": "AN",
        "tld": ".gs",
        "CurrencyCode": "GBP",
        "CurrencyName": "Pound",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en",
        "geonameid": 3474415,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GT": {
        "ISO3": "GTM",
        "ISO-Numeric": 320,
        "fips": "GT",
        "Country": "Guatemala",
        "Capital": "Guatemala City",
        "Area(in sq km)": 108890,
        "Population": 13550440,
        "Continent": "NA",
        "tld": ".gt",
        "CurrencyCode": "GTQ",
        "CurrencyName": "Quetzal",
        "Phone": 502,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-GT",
        "geonameid": 3595528,
        "neighbours": "MX,HN,BZ,SV",
        "EquivalentFipsCode": ""
    },
    "GU": {
        "ISO3": "GUM",
        "ISO-Numeric": 316,
        "fips": "GQ",
        "Country": "Guam",
        "Capital": "Hagatna",
        "Area(in sq km)": 549,
        "Population": 159358,
        "Continent": "OC",
        "tld": ".gu",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-671",
        "Postal Code Format": "969##",
        "Postal Code Regex": "^(969\\d{2})$",
        "Languages": "en-GU,ch-GU",
        "geonameid": 4043988,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "GW": {
        "ISO3": "GNB",
        "ISO-Numeric": 624,
        "fips": "PU",
        "Country": "Guinea-Bissau",
        "Capital": "Bissau",
        "Area(in sq km)": 36120,
        "Population": 1565126,
        "Continent": "AF",
        "tld": ".gw",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 245,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "pt-GW,pov",
        "geonameid": 2372248,
        "neighbours": "SN,GN",
        "EquivalentFipsCode": ""
    },
    "GY": {
        "ISO3": "GUY",
        "ISO-Numeric": 328,
        "fips": "GY",
        "Country": "Guyana",
        "Capital": "Georgetown",
        "Area(in sq km)": 214970,
        "Population": 748486,
        "Continent": "SA",
        "tld": ".gy",
        "CurrencyCode": "GYD",
        "CurrencyName": "Dollar",
        "Phone": 592,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-GY",
        "geonameid": 3378535,
        "neighbours": "SR,BR,VE",
        "EquivalentFipsCode": ""
    },
    "HK": {
        "ISO3": "HKG",
        "ISO-Numeric": 344,
        "fips": "HK",
        "Country": "Hong Kong",
        "Capital": "Hong Kong",
        "Area(in sq km)": 1092,
        "Population": 6898686,
        "Continent": "AS",
        "tld": ".hk",
        "CurrencyCode": "HKD",
        "CurrencyName": "Dollar",
        "Phone": 852,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "zh-HK,yue,zh,en",
        "geonameid": 1819730,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "HM": {
        "ISO3": "HMD",
        "ISO-Numeric": 334,
        "fips": "HM",
        "Country": "Heard Island and McDonald Islands",
        "Capital": "",
        "Area(in sq km)": 412,
        "Population": 0,
        "Continent": "AN",
        "tld": ".hm",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "",
        "geonameid": 1547314,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "HN": {
        "ISO3": "HND",
        "ISO-Numeric": 340,
        "fips": "HO",
        "Country": "Honduras",
        "Capital": "Tegucigalpa",
        "Area(in sq km)": 112090,
        "Population": 7989415,
        "Continent": "NA",
        "tld": ".hn",
        "CurrencyCode": "HNL",
        "CurrencyName": "Lempira",
        "Phone": 504,
        "Postal Code Format": "@@####",
        "Postal Code Regex": "^([A-Z]{2}\\d{4})$",
        "Languages": "es-HN",
        "geonameid": 3608932,
        "neighbours": "GT,NI,SV",
        "EquivalentFipsCode": ""
    },
    "HR": {
        "ISO3": "HRV",
        "ISO-Numeric": 191,
        "fips": "HR",
        "Country": "Croatia",
        "Capital": "Zagreb",
        "Area(in sq km)": 56542,
        "Population": 4284889,
        "Continent": "EU",
        "tld": ".hr",
        "CurrencyCode": "HRK",
        "CurrencyName": "Kuna",
        "Phone": 385,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(?:HR)*(\\d{5})$",
        "Languages": "hr-HR,sr",
        "geonameid": 3202326,
        "neighbours": "HU,SI,BA,ME,RS",
        "EquivalentFipsCode": ""
    },
    "HT": {
        "ISO3": "HTI",
        "ISO-Numeric": 332,
        "fips": "HA",
        "Country": "Haiti",
        "Capital": "Port-au-Prince",
        "Area(in sq km)": 27750,
        "Population": 9648924,
        "Continent": "NA",
        "tld": ".ht",
        "CurrencyCode": "HTG",
        "CurrencyName": "Gourde",
        "Phone": 509,
        "Postal Code Format": "HT####",
        "Postal Code Regex": "^(?:HT)*(\\d{4})$",
        "Languages": "ht,fr-HT",
        "geonameid": 3723988,
        "neighbours": "DO",
        "EquivalentFipsCode": ""
    },
    "HU": {
        "ISO3": "HUN",
        "ISO-Numeric": 348,
        "fips": "HU",
        "Country": "Hungary",
        "Capital": "Budapest",
        "Area(in sq km)": 93030,
        "Population": 9982000,
        "Continent": "EU",
        "tld": ".hu",
        "CurrencyCode": "HUF",
        "CurrencyName": "Forint",
        "Phone": 36,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "hu-HU",
        "geonameid": 719819,
        "neighbours": "SK,SI,RO,UA,HR,AT,RS",
        "EquivalentFipsCode": ""
    },
    "ID": {
        "ISO3": "IDN",
        "ISO-Numeric": 360,
        "fips": "ID",
        "Country": "Indonesia",
        "Capital": "Jakarta",
        "Area(in sq km)": 1919440,
        "Population": 242968342,
        "Continent": "AS",
        "tld": ".id",
        "CurrencyCode": "IDR",
        "CurrencyName": "Rupiah",
        "Phone": 62,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "id,en,nl,jv",
        "geonameid": 1643084,
        "neighbours": "PG,TL,MY",
        "EquivalentFipsCode": ""
    },
    "IE": {
        "ISO3": "IRL",
        "ISO-Numeric": 372,
        "fips": "EI",
        "Country": "Ireland",
        "Capital": "Dublin",
        "Area(in sq km)": 70280,
        "Population": 4622917,
        "Continent": "EU",
        "tld": ".ie",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 353,
        "Postal Code Format": "@@@ @@@@",
        "Postal Code Regex": "^[A-Z]\\d{2}$|^[A-Z]{3}[A-Z]{4}$",
        "Languages": "en-IE,ga-IE",
        "geonameid": 2963597,
        "neighbours": "GB",
        "EquivalentFipsCode": ""
    },
    "IL": {
        "ISO3": "ISR",
        "ISO-Numeric": 376,
        "fips": "IS",
        "Country": "Israel",
        "Capital": "Jerusalem",
        "Area(in sq km)": 20770,
        "Population": 7353985,
        "Continent": "AS",
        "tld": ".il",
        "CurrencyCode": "ILS",
        "CurrencyName": "Shekel",
        "Phone": 972,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "he,ar-IL,en-IL,",
        "geonameid": 294640,
        "neighbours": "SY,JO,LB,EG,PS",
        "EquivalentFipsCode": ""
    },
    "IM": {
        "ISO3": "IMN",
        "ISO-Numeric": 833,
        "fips": "IM",
        "Country": "Isle of Man",
        "Capital": "Douglas",
        "Area(in sq km)": 572,
        "Population": 75049,
        "Continent": "EU",
        "tld": ".im",
        "CurrencyCode": "GBP",
        "CurrencyName": "Pound",
        "Phone": "+44-1624",
        "Postal Code Format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
        "Postal Code Regex": "^((?:(?:[A-PR-UWYZ][A-HK-Y]\\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\\d[A-HJKPS-UW0-9])\\s\\d[ABD-HJLNP-UW-Z]{2})|GIR\\s?0AA)$",
        "Languages": "en,gv",
        "geonameid": 3042225,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "IN": {
        "ISO3": "IND",
        "ISO-Numeric": 356,
        "fips": "IN",
        "Country": "India",
        "Capital": "New Delhi",
        "Area(in sq km)": 3287590,
        "Population": 1173108018,
        "Continent": "AS",
        "tld": ".in",
        "CurrencyCode": "INR",
        "CurrencyName": "Rupee",
        "Phone": 91,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "en-IN,hi,bn,te,mr,ta,ur,gu,kn,ml,or,pa,as,bh,sat,ks,ne,sd,kok,doi,mni,sit,sa,fr,lus,inc",
        "geonameid": 1269750,
        "neighbours": "CN,NP,MM,BT,PK,BD",
        "EquivalentFipsCode": ""
    },
    "IO": {
        "ISO3": "IOT",
        "ISO-Numeric": 86,
        "fips": "IO",
        "Country": "British Indian Ocean Territory",
        "Capital": "Diego Garcia",
        "Area(in sq km)": 60,
        "Population": 4000,
        "Continent": "AS",
        "tld": ".io",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 246,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-IO",
        "geonameid": 1282588,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "IQ": {
        "ISO3": "IRQ",
        "ISO-Numeric": 368,
        "fips": "IZ",
        "Country": "Iraq",
        "Capital": "Baghdad",
        "Area(in sq km)": 437072,
        "Population": 29671605,
        "Continent": "AS",
        "tld": ".iq",
        "CurrencyCode": "IQD",
        "CurrencyName": "Dinar",
        "Phone": 964,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-IQ,ku,hy",
        "geonameid": 99237,
        "neighbours": "SY,SA,IR,JO,TR,KW",
        "EquivalentFipsCode": ""
    },
    "IR": {
        "ISO3": "IRN",
        "ISO-Numeric": 364,
        "fips": "IR",
        "Country": "Iran",
        "Capital": "Tehran",
        "Area(in sq km)": 1648000,
        "Population": 76923300,
        "Continent": "AS",
        "tld": ".ir",
        "CurrencyCode": "IRR",
        "CurrencyName": "Rial",
        "Phone": 98,
        "Postal Code Format": "##########",
        "Postal Code Regex": "^(\\d{10})$",
        "Languages": "fa-IR,ku",
        "geonameid": 130758,
        "neighbours": "TM,AF,IQ,AM,PK,AZ,TR",
        "EquivalentFipsCode": ""
    },
    "IS": {
        "ISO3": "ISL",
        "ISO-Numeric": 352,
        "fips": "IC",
        "Country": "Iceland",
        "Capital": "Reykjavik",
        "Area(in sq km)": 103000,
        "Population": 308910,
        "Continent": "EU",
        "tld": ".is",
        "CurrencyCode": "ISK",
        "CurrencyName": "Krona",
        "Phone": 354,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(\\d{3})$",
        "Languages": "is,en,de,da,sv,no",
        "geonameid": 2629691,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "IT": {
        "ISO3": "ITA",
        "ISO-Numeric": 380,
        "fips": "IT",
        "Country": "Italy",
        "Capital": "Rome",
        "Area(in sq km)": 301230,
        "Population": 60340328,
        "Continent": "EU",
        "tld": ".it",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 39,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "it-IT,de-IT,fr-IT,sc,ca,co,sl",
        "geonameid": 3175395,
        "neighbours": "CH,VA,SI,SM,FR,AT",
        "EquivalentFipsCode": ""
    },
    "JE": {
        "ISO3": "JEY",
        "ISO-Numeric": 832,
        "fips": "JE",
        "Country": "Jersey",
        "Capital": "Saint Helier",
        "Area(in sq km)": 116,
        "Population": 90812,
        "Continent": "EU",
        "tld": ".je",
        "CurrencyCode": "GBP",
        "CurrencyName": "Pound",
        "Phone": "+44-1534",
        "Postal Code Format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
        "Postal Code Regex": "^((?:(?:[A-PR-UWYZ][A-HK-Y]\\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\\d[A-HJKPS-UW0-9])\\s\\d[ABD-HJLNP-UW-Z]{2})|GIR\\s?0AA)$",
        "Languages": "en,pt",
        "geonameid": 3042142,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "JM": {
        "ISO3": "JAM",
        "ISO-Numeric": 388,
        "fips": "JM",
        "Country": "Jamaica",
        "Capital": "Kingston",
        "Area(in sq km)": 10991,
        "Population": 2847232,
        "Continent": "NA",
        "tld": ".jm",
        "CurrencyCode": "JMD",
        "CurrencyName": "Dollar",
        "Phone": "+1-876",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-JM",
        "geonameid": 3489940,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "JO": {
        "ISO3": "JOR",
        "ISO-Numeric": 400,
        "fips": "JO",
        "Country": "Jordan",
        "Capital": "Amman",
        "Area(in sq km)": 92300,
        "Population": 6407085,
        "Continent": "AS",
        "tld": ".jo",
        "CurrencyCode": "JOD",
        "CurrencyName": "Dinar",
        "Phone": 962,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-JO,en",
        "geonameid": 248816,
        "neighbours": "SY,SA,IQ,IL,PS",
        "EquivalentFipsCode": ""
    },
    "JP": {
        "ISO3": "JPN",
        "ISO-Numeric": 392,
        "fips": "JA",
        "Country": "Japan",
        "Capital": "Tokyo",
        "Area(in sq km)": 377835,
        "Population": 127288000,
        "Continent": "AS",
        "tld": ".jp",
        "CurrencyCode": "JPY",
        "CurrencyName": "Yen",
        "Phone": 81,
        "Postal Code Format": "###-####",
        "Postal Code Regex": "^\\d{3}-\\d{4}$",
        "Languages": "ja",
        "geonameid": 1861060,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "KE": {
        "ISO3": "KEN",
        "ISO-Numeric": 404,
        "fips": "KE",
        "Country": "Kenya",
        "Capital": "Nairobi",
        "Area(in sq km)": 582650,
        "Population": 40046566,
        "Continent": "AF",
        "tld": ".ke",
        "CurrencyCode": "KES",
        "CurrencyName": "Shilling",
        "Phone": 254,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "en-KE,sw-KE",
        "geonameid": 192950,
        "neighbours": "ET,TZ,SS,SO,UG",
        "EquivalentFipsCode": ""
    },
    "KG": {
        "ISO3": "KGZ",
        "ISO-Numeric": 417,
        "fips": "KG",
        "Country": "Kyrgyzstan",
        "Capital": "Bishkek",
        "Area(in sq km)": 198500,
        "Population": 5776500,
        "Continent": "AS",
        "tld": ".kg",
        "CurrencyCode": "KGS",
        "CurrencyName": "Som",
        "Phone": 996,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "ky,uz,ru",
        "geonameid": 1527747,
        "neighbours": "CN,TJ,UZ,KZ",
        "EquivalentFipsCode": ""
    },
    "KH": {
        "ISO3": "KHM",
        "ISO-Numeric": 116,
        "fips": "CB",
        "Country": "Cambodia",
        "Capital": "Phnom Penh",
        "Area(in sq km)": 181040,
        "Population": 14453680,
        "Continent": "AS",
        "tld": ".kh",
        "CurrencyCode": "KHR",
        "CurrencyName": "Riels",
        "Phone": 855,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "km,fr,en",
        "geonameid": 1831722,
        "neighbours": "LA,TH,VN",
        "EquivalentFipsCode": ""
    },
    "KI": {
        "ISO3": "KIR",
        "ISO-Numeric": 296,
        "fips": "KR",
        "Country": "Kiribati",
        "Capital": "Tarawa",
        "Area(in sq km)": 811,
        "Population": 92533,
        "Continent": "OC",
        "tld": ".ki",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 686,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-KI,gil",
        "geonameid": 4030945,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "KM": {
        "ISO3": "COM",
        "ISO-Numeric": 174,
        "fips": "CN",
        "Country": "Comoros",
        "Capital": "Moroni",
        "Area(in sq km)": 2170,
        "Population": 773407,
        "Continent": "AF",
        "tld": ".km",
        "CurrencyCode": "KMF",
        "CurrencyName": "Franc",
        "Phone": 269,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar,fr-KM",
        "geonameid": 921929,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "KN": {
        "ISO3": "KNA",
        "ISO-Numeric": 659,
        "fips": "SC",
        "Country": "Saint Kitts and Nevis",
        "Capital": "Basseterre",
        "Area(in sq km)": 261,
        "Population": 51134,
        "Continent": "NA",
        "tld": ".kn",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-869",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-KN",
        "geonameid": 3575174,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "KP": {
        "ISO3": "PRK",
        "ISO-Numeric": 408,
        "fips": "KN",
        "Country": "North Korea",
        "Capital": "Pyongyang",
        "Area(in sq km)": 120540,
        "Population": 22912177,
        "Continent": "AS",
        "tld": ".kp",
        "CurrencyCode": "KPW",
        "CurrencyName": "Won",
        "Phone": 850,
        "Postal Code Format": "###-###",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "ko-KP",
        "geonameid": 1873107,
        "neighbours": "CN,KR,RU",
        "EquivalentFipsCode": ""
    },
    "KR": {
        "ISO3": "KOR",
        "ISO-Numeric": 410,
        "fips": "KS",
        "Country": "South Korea",
        "Capital": "Seoul",
        "Area(in sq km)": 98480,
        "Population": 48422644,
        "Continent": "AS",
        "tld": ".kr",
        "CurrencyCode": "KRW",
        "CurrencyName": "Won",
        "Phone": 82,
        "Postal Code Format": "SEOUL ###-###",
        "Postal Code Regex": "^(?:SEOUL)*(\\d{6})$",
        "Languages": "ko-KR,en",
        "geonameid": 1835841,
        "neighbours": "KP",
        "EquivalentFipsCode": ""
    },
    "XK": {
        "ISO3": "XKX",
        "ISO-Numeric": 0,
        "fips": "KV",
        "Country": "Kosovo",
        "Capital": "Pristina",
        "Area(in sq km)": 10908,
        "Population": 1800000,
        "Continent": "EU",
        "tld": "",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "sq,sr",
        "geonameid": 831053,
        "neighbours": "RS,AL,MK,ME",
        "EquivalentFipsCode": ""
    },
    "KW": {
        "ISO3": "KWT",
        "ISO-Numeric": 414,
        "fips": "KU",
        "Country": "Kuwait",
        "Capital": "Kuwait City",
        "Area(in sq km)": 17820,
        "Population": 2789132,
        "Continent": "AS",
        "tld": ".kw",
        "CurrencyCode": "KWD",
        "CurrencyName": "Dinar",
        "Phone": 965,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-KW,en",
        "geonameid": 285570,
        "neighbours": "SA,IQ",
        "EquivalentFipsCode": ""
    },
    "KY": {
        "ISO3": "CYM",
        "ISO-Numeric": 136,
        "fips": "CJ",
        "Country": "Cayman Islands",
        "Capital": "George Town",
        "Area(in sq km)": 262,
        "Population": 44270,
        "Continent": "NA",
        "tld": ".ky",
        "CurrencyCode": "KYD",
        "CurrencyName": "Dollar",
        "Phone": "+1-345",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-KY",
        "geonameid": 3580718,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "KZ": {
        "ISO3": "KAZ",
        "ISO-Numeric": 398,
        "fips": "KZ",
        "Country": "Kazakhstan",
        "Capital": "Astana",
        "Area(in sq km)": 2717300,
        "Population": 15340000,
        "Continent": "AS",
        "tld": ".kz",
        "CurrencyCode": "KZT",
        "CurrencyName": "Tenge",
        "Phone": 7,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "kk,ru",
        "geonameid": 1522867,
        "neighbours": "TM,CN,KG,UZ,RU",
        "EquivalentFipsCode": ""
    },
    "LA": {
        "ISO3": "LAO",
        "ISO-Numeric": 418,
        "fips": "LA",
        "Country": "Laos",
        "Capital": "Vientiane",
        "Area(in sq km)": 236800,
        "Population": 6368162,
        "Continent": "AS",
        "tld": ".la",
        "CurrencyCode": "LAK",
        "CurrencyName": "Kip",
        "Phone": 856,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "lo,fr,en",
        "geonameid": 1655842,
        "neighbours": "CN,MM,KH,TH,VN",
        "EquivalentFipsCode": ""
    },
    "LB": {
        "ISO3": "LBN",
        "ISO-Numeric": 422,
        "fips": "LE",
        "Country": "Lebanon",
        "Capital": "Beirut",
        "Area(in sq km)": 10400,
        "Population": 4125247,
        "Continent": "AS",
        "tld": ".lb",
        "CurrencyCode": "LBP",
        "CurrencyName": "Pound",
        "Phone": 961,
        "Postal Code Format": "#### ####|####",
        "Postal Code Regex": "^(\\d{4}(\\d{4})?)$",
        "Languages": "ar-LB,fr-LB,en,hy",
        "geonameid": 272103,
        "neighbours": "SY,IL",
        "EquivalentFipsCode": ""
    },
    "LC": {
        "ISO3": "LCA",
        "ISO-Numeric": 662,
        "fips": "ST",
        "Country": "Saint Lucia",
        "Capital": "Castries",
        "Area(in sq km)": 616,
        "Population": 160922,
        "Continent": "NA",
        "tld": ".lc",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-758",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-LC",
        "geonameid": 3576468,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "LI": {
        "ISO3": "LIE",
        "ISO-Numeric": 438,
        "fips": "LS",
        "Country": "Liechtenstein",
        "Capital": "Vaduz",
        "Area(in sq km)": 160,
        "Population": 35000,
        "Continent": "EU",
        "tld": ".li",
        "CurrencyCode": "CHF",
        "CurrencyName": "Franc",
        "Phone": 423,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "de-LI",
        "geonameid": 3042058,
        "neighbours": "CH,AT",
        "EquivalentFipsCode": ""
    },
    "LK": {
        "ISO3": "LKA",
        "ISO-Numeric": 144,
        "fips": "CE",
        "Country": "Sri Lanka",
        "Capital": "Colombo",
        "Area(in sq km)": 65610,
        "Population": 21513990,
        "Continent": "AS",
        "tld": ".lk",
        "CurrencyCode": "LKR",
        "CurrencyName": "Rupee",
        "Phone": 94,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "si,ta,en",
        "geonameid": 1227603,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "LR": {
        "ISO3": "LBR",
        "ISO-Numeric": 430,
        "fips": "LI",
        "Country": "Liberia",
        "Capital": "Monrovia",
        "Area(in sq km)": 111370,
        "Population": 3685076,
        "Continent": "AF",
        "tld": ".lr",
        "CurrencyCode": "LRD",
        "CurrencyName": "Dollar",
        "Phone": 231,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "en-LR",
        "geonameid": 2275384,
        "neighbours": "SL,CI,GN",
        "EquivalentFipsCode": ""
    },
    "LS": {
        "ISO3": "LSO",
        "ISO-Numeric": 426,
        "fips": "LT",
        "Country": "Lesotho",
        "Capital": "Maseru",
        "Area(in sq km)": 30355,
        "Population": 1919552,
        "Continent": "AF",
        "tld": ".ls",
        "CurrencyCode": "LSL",
        "CurrencyName": "Loti",
        "Phone": 266,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(\\d{3})$",
        "Languages": "en-LS,st,zu,xh",
        "geonameid": 932692,
        "neighbours": "ZA",
        "EquivalentFipsCode": ""
    },
    "LT": {
        "ISO3": "LTU",
        "ISO-Numeric": 440,
        "fips": "LH",
        "Country": "Lithuania",
        "Capital": "Vilnius",
        "Area(in sq km)": 65200,
        "Population": 2944459,
        "Continent": "EU",
        "tld": ".lt",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 370,
        "Postal Code Format": "LT-#####",
        "Postal Code Regex": "^(?:LT)*(\\d{5})$",
        "Languages": "lt,ru,pl",
        "geonameid": 597427,
        "neighbours": "PL,BY,RU,LV",
        "EquivalentFipsCode": ""
    },
    "LU": {
        "ISO3": "LUX",
        "ISO-Numeric": 442,
        "fips": "LU",
        "Country": "Luxembourg",
        "Capital": "Luxembourg",
        "Area(in sq km)": 2586,
        "Population": 497538,
        "Continent": "EU",
        "tld": ".lu",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 352,
        "Postal Code Format": "L-####",
        "Postal Code Regex": "^(?:L-)?\\d{4}$",
        "Languages": "lb,de-LU,fr-LU",
        "geonameid": 2960313,
        "neighbours": "DE,BE,FR",
        "EquivalentFipsCode": ""
    },
    "LV": {
        "ISO3": "LVA",
        "ISO-Numeric": 428,
        "fips": "LG",
        "Country": "Latvia",
        "Capital": "Riga",
        "Area(in sq km)": 64589,
        "Population": 2217969,
        "Continent": "EU",
        "tld": ".lv",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 371,
        "Postal Code Format": "LV-####",
        "Postal Code Regex": "^(?:LV)*(\\d{4})$",
        "Languages": "lv,ru,lt",
        "geonameid": 458258,
        "neighbours": "LT,EE,BY,RU",
        "EquivalentFipsCode": ""
    },
    "LY": {
        "ISO3": "LBY",
        "ISO-Numeric": 434,
        "fips": "LY",
        "Country": "Libya",
        "Capital": "Tripoli",
        "Area(in sq km)": 1759540,
        "Population": 6461454,
        "Continent": "AF",
        "tld": ".ly",
        "CurrencyCode": "LYD",
        "CurrencyName": "Dinar",
        "Phone": 218,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-LY,it,en",
        "geonameid": 2215636,
        "neighbours": "TD,NE,DZ,SD,TN,EG",
        "EquivalentFipsCode": ""
    },
    "MA": {
        "ISO3": "MAR",
        "ISO-Numeric": 504,
        "fips": "MO",
        "Country": "Morocco",
        "Capital": "Rabat",
        "Area(in sq km)": 446550,
        "Population": 33848242,
        "Continent": "AF",
        "tld": ".ma",
        "CurrencyCode": "MAD",
        "CurrencyName": "Dirham",
        "Phone": 212,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-MA,ber,fr",
        "geonameid": 2542007,
        "neighbours": "DZ,EH,ES",
        "EquivalentFipsCode": ""
    },
    "MC": {
        "ISO3": "MCO",
        "ISO-Numeric": 492,
        "fips": "MN",
        "Country": "Monaco",
        "Capital": "Monaco",
        "Area(in sq km)": 1.95,
        "Population": 32965,
        "Continent": "EU",
        "tld": ".mc",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 377,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-MC,en,it",
        "geonameid": 2993457,
        "neighbours": "FR",
        "EquivalentFipsCode": ""
    },
    "MD": {
        "ISO3": "MDA",
        "ISO-Numeric": 498,
        "fips": "MD",
        "Country": "Moldova",
        "Capital": "Chisinau",
        "Area(in sq km)": 33843,
        "Population": 4324000,
        "Continent": "EU",
        "tld": ".md",
        "CurrencyCode": "MDL",
        "CurrencyName": "Leu",
        "Phone": 373,
        "Postal Code Format": "MD-####",
        "Postal Code Regex": "^MD-\\d{4}$",
        "Languages": "ro,ru,gag,tr",
        "geonameid": 617790,
        "neighbours": "RO,UA",
        "EquivalentFipsCode": ""
    },
    "ME": {
        "ISO3": "MNE",
        "ISO-Numeric": 499,
        "fips": "MJ",
        "Country": "Montenegro",
        "Capital": "Podgorica",
        "Area(in sq km)": 14026,
        "Population": 666730,
        "Continent": "EU",
        "tld": ".me",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 382,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "sr,hu,bs,sq,hr,rom",
        "geonameid": 3194884,
        "neighbours": "AL,HR,BA,RS,XK",
        "EquivalentFipsCode": ""
    },
    "MF": {
        "ISO3": "MAF",
        "ISO-Numeric": 663,
        "fips": "RN",
        "Country": "Saint Martin",
        "Capital": "Marigot",
        "Area(in sq km)": 53,
        "Population": 35925,
        "Continent": "NA",
        "tld": ".gp",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 590,
        "Postal Code Format": "### ###",
        "Postal Code Regex": "",
        "Languages": "fr",
        "geonameid": 3578421,
        "neighbours": "SX",
        "EquivalentFipsCode": ""
    },
    "MG": {
        "ISO3": "MDG",
        "ISO-Numeric": 450,
        "fips": "MA",
        "Country": "Madagascar",
        "Capital": "Antananarivo",
        "Area(in sq km)": 587040,
        "Population": 21281844,
        "Continent": "AF",
        "tld": ".mg",
        "CurrencyCode": "MGA",
        "CurrencyName": "Ariary",
        "Phone": 261,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(\\d{3})$",
        "Languages": "fr-MG,mg",
        "geonameid": 1062947,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MH": {
        "ISO3": "MHL",
        "ISO-Numeric": 584,
        "fips": "RM",
        "Country": "Marshall Islands",
        "Capital": "Majuro",
        "Area(in sq km)": 181.3,
        "Population": 65859,
        "Continent": "OC",
        "tld": ".mh",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 692,
        "Postal Code Format": "#####-####",
        "Postal Code Regex": "^969\\d{2}(-\\d{4})$",
        "Languages": "mh,en-MH",
        "geonameid": 2080185,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MK": {
        "ISO3": "MKD",
        "ISO-Numeric": 807,
        "fips": "MK",
        "Country": "Macedonia",
        "Capital": "Skopje",
        "Area(in sq km)": 25333,
        "Population": 2062294,
        "Continent": "EU",
        "tld": ".mk",
        "CurrencyCode": "MKD",
        "CurrencyName": "Denar",
        "Phone": 389,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "mk,sq,tr,rmm,sr",
        "geonameid": 718075,
        "neighbours": "AL,GR,BG,RS,XK",
        "EquivalentFipsCode": ""
    },
    "ML": {
        "ISO3": "MLI",
        "ISO-Numeric": 466,
        "fips": "ML",
        "Country": "Mali",
        "Capital": "Bamako",
        "Area(in sq km)": 1240000,
        "Population": 13796354,
        "Continent": "AF",
        "tld": ".ml",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 223,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-ML,bm",
        "geonameid": 2453866,
        "neighbours": "SN,NE,DZ,CI,GN,MR,BF",
        "EquivalentFipsCode": ""
    },
    "MM": {
        "ISO3": "MMR",
        "ISO-Numeric": 104,
        "fips": "BM",
        "Country": "Myanmar",
        "Capital": "Nay Pyi Taw",
        "Area(in sq km)": 678500,
        "Population": 53414374,
        "Continent": "AS",
        "tld": ".mm",
        "CurrencyCode": "MMK",
        "CurrencyName": "Kyat",
        "Phone": 95,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "my",
        "geonameid": 1327865,
        "neighbours": "CN,LA,TH,BD,IN",
        "EquivalentFipsCode": ""
    },
    "MN": {
        "ISO3": "MNG",
        "ISO-Numeric": 496,
        "fips": "MG",
        "Country": "Mongolia",
        "Capital": "Ulan Bator",
        "Area(in sq km)": 1565000,
        "Population": 3086918,
        "Continent": "AS",
        "tld": ".mn",
        "CurrencyCode": "MNT",
        "CurrencyName": "Tugrik",
        "Phone": 976,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "mn,ru",
        "geonameid": 2029969,
        "neighbours": "CN,RU",
        "EquivalentFipsCode": ""
    },
    "MO": {
        "ISO3": "MAC",
        "ISO-Numeric": 446,
        "fips": "MC",
        "Country": "Macao",
        "Capital": "Macao",
        "Area(in sq km)": 254,
        "Population": 449198,
        "Continent": "AS",
        "tld": ".mo",
        "CurrencyCode": "MOP",
        "CurrencyName": "Pataca",
        "Phone": 853,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "zh,zh-MO,pt",
        "geonameid": 1821275,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MP": {
        "ISO3": "MNP",
        "ISO-Numeric": 580,
        "fips": "CQ",
        "Country": "Northern Mariana Islands",
        "Capital": "Saipan",
        "Area(in sq km)": 477,
        "Population": 53883,
        "Continent": "OC",
        "tld": ".mp",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-670",
        "Postal Code Format": "#####-####",
        "Postal Code Regex": "^9695\\d{1}(-\\d{4})$",
        "Languages": "fil,tl,zh,ch-MP,en-MP",
        "geonameid": 4041468,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MQ": {
        "ISO3": "MTQ",
        "ISO-Numeric": 474,
        "fips": "MB",
        "Country": "Martinique",
        "Capital": "Fort-de-France",
        "Area(in sq km)": 1100,
        "Population": 432900,
        "Continent": "NA",
        "tld": ".mq",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 596,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-MQ",
        "geonameid": 3570311,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MR": {
        "ISO3": "MRT",
        "ISO-Numeric": 478,
        "fips": "MR",
        "Country": "Mauritania",
        "Capital": "Nouakchott",
        "Area(in sq km)": 1030700,
        "Population": 3205060,
        "Continent": "AF",
        "tld": ".mr",
        "CurrencyCode": "MRO",
        "CurrencyName": "Ouguiya",
        "Phone": 222,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-MR,fuc,snk,fr,mey,wo",
        "geonameid": 2378080,
        "neighbours": "SN,DZ,EH,ML",
        "EquivalentFipsCode": ""
    },
    "MS": {
        "ISO3": "MSR",
        "ISO-Numeric": 500,
        "fips": "MH",
        "Country": "Montserrat",
        "Capital": "Plymouth",
        "Area(in sq km)": 102,
        "Population": 9341,
        "Continent": "NA",
        "tld": ".ms",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-664",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-MS",
        "geonameid": 3578097,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MT": {
        "ISO3": "MLT",
        "ISO-Numeric": 470,
        "fips": "MT",
        "Country": "Malta",
        "Capital": "Valletta",
        "Area(in sq km)": 316,
        "Population": 403000,
        "Continent": "EU",
        "tld": ".mt",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 356,
        "Postal Code Format": "@@@ ####",
        "Postal Code Regex": "^[A-Z]{3}\\s?\\d{4}$",
        "Languages": "mt,en-MT",
        "geonameid": 2562770,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MU": {
        "ISO3": "MUS",
        "ISO-Numeric": 480,
        "fips": "MP",
        "Country": "Mauritius",
        "Capital": "Port Louis",
        "Area(in sq km)": 2040,
        "Population": 1294104,
        "Continent": "AF",
        "tld": ".mu",
        "CurrencyCode": "MUR",
        "CurrencyName": "Rupee",
        "Phone": 230,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-MU,bho,fr",
        "geonameid": 934292,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MV": {
        "ISO3": "MDV",
        "ISO-Numeric": 462,
        "fips": "MV",
        "Country": "Maldives",
        "Capital": "Male",
        "Area(in sq km)": 300,
        "Population": 395650,
        "Continent": "AS",
        "tld": ".mv",
        "CurrencyCode": "MVR",
        "CurrencyName": "Rufiyaa",
        "Phone": 960,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "dv,en",
        "geonameid": 1282028,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "MW": {
        "ISO3": "MWI",
        "ISO-Numeric": 454,
        "fips": "MI",
        "Country": "Malawi",
        "Capital": "Lilongwe",
        "Area(in sq km)": 118480,
        "Population": 15447500,
        "Continent": "AF",
        "tld": ".mw",
        "CurrencyCode": "MWK",
        "CurrencyName": "Kwacha",
        "Phone": 265,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ny,yao,tum,swk",
        "geonameid": 927384,
        "neighbours": "TZ,MZ,ZM",
        "EquivalentFipsCode": ""
    },
    "MX": {
        "ISO3": "MEX",
        "ISO-Numeric": 484,
        "fips": "MX",
        "Country": "Mexico",
        "Capital": "Mexico City",
        "Area(in sq km)": 1972550,
        "Population": 112468855,
        "Continent": "NA",
        "tld": ".mx",
        "CurrencyCode": "MXN",
        "CurrencyName": "Peso",
        "Phone": 52,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-MX",
        "geonameid": 3996063,
        "neighbours": "GT,US,BZ",
        "EquivalentFipsCode": ""
    },
    "MY": {
        "ISO3": "MYS",
        "ISO-Numeric": 458,
        "fips": "MY",
        "Country": "Malaysia",
        "Capital": "Kuala Lumpur",
        "Area(in sq km)": 329750,
        "Population": 28274729,
        "Continent": "AS",
        "tld": ".my",
        "CurrencyCode": "MYR",
        "CurrencyName": "Ringgit",
        "Phone": 60,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ms-MY,en,zh,ta,te,ml,pa,th",
        "geonameid": 1733045,
        "neighbours": "BN,TH,ID",
        "EquivalentFipsCode": ""
    },
    "MZ": {
        "ISO3": "MOZ",
        "ISO-Numeric": 508,
        "fips": "MZ",
        "Country": "Mozambique",
        "Capital": "Maputo",
        "Area(in sq km)": 801590,
        "Population": 22061451,
        "Continent": "AF",
        "tld": ".mz",
        "CurrencyCode": "MZN",
        "CurrencyName": "Metical",
        "Phone": 258,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "pt-MZ,vmw",
        "geonameid": 1036973,
        "neighbours": "ZW,TZ,SZ,ZA,ZM,MW",
        "EquivalentFipsCode": ""
    },
    "NA": {
        "ISO3": "NAM",
        "ISO-Numeric": 516,
        "fips": "WA",
        "Country": "Namibia",
        "Capital": "Windhoek",
        "Area(in sq km)": 825418,
        "Population": 2128471,
        "Continent": "AF",
        "tld": ".na",
        "CurrencyCode": "NAD",
        "CurrencyName": "Dollar",
        "Phone": 264,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-NA,af,de,hz,naq",
        "geonameid": 3355338,
        "neighbours": "ZA,BW,ZM,AO",
        "EquivalentFipsCode": ""
    },
    "NC": {
        "ISO3": "NCL",
        "ISO-Numeric": 540,
        "fips": "NC",
        "Country": "New Caledonia",
        "Capital": "Noumea",
        "Area(in sq km)": 19060,
        "Population": 216494,
        "Continent": "OC",
        "tld": ".nc",
        "CurrencyCode": "XPF",
        "CurrencyName": "Franc",
        "Phone": 687,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-NC",
        "geonameid": 2139685,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "NE": {
        "ISO3": "NER",
        "ISO-Numeric": 562,
        "fips": "NG",
        "Country": "Niger",
        "Capital": "Niamey",
        "Area(in sq km)": 1267000,
        "Population": 15878271,
        "Continent": "AF",
        "tld": ".ne",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 227,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "fr-NE,ha,kr,dje",
        "geonameid": 2440476,
        "neighbours": "TD,BJ,DZ,LY,BF,NG,ML",
        "EquivalentFipsCode": ""
    },
    "NF": {
        "ISO3": "NFK",
        "ISO-Numeric": 574,
        "fips": "NF",
        "Country": "Norfolk Island",
        "Capital": "Kingston",
        "Area(in sq km)": 34.6,
        "Population": 1828,
        "Continent": "OC",
        "tld": ".nf",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 672,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "en-NF",
        "geonameid": 2155115,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "NG": {
        "ISO3": "NGA",
        "ISO-Numeric": 566,
        "fips": "NI",
        "Country": "Nigeria",
        "Capital": "Abuja",
        "Area(in sq km)": 923768,
        "Population": 154000000,
        "Continent": "AF",
        "tld": ".ng",
        "CurrencyCode": "NGN",
        "CurrencyName": "Naira",
        "Phone": 234,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "en-NG,ha,yo,ig,ff",
        "geonameid": 2328926,
        "neighbours": "TD,NE,BJ,CM",
        "EquivalentFipsCode": ""
    },
    "NI": {
        "ISO3": "NIC",
        "ISO-Numeric": 558,
        "fips": "NU",
        "Country": "Nicaragua",
        "Capital": "Managua",
        "Area(in sq km)": 129494,
        "Population": 5995928,
        "Continent": "NA",
        "tld": ".ni",
        "CurrencyCode": "NIO",
        "CurrencyName": "Cordoba",
        "Phone": 505,
        "Postal Code Format": "###-###-#",
        "Postal Code Regex": "^(\\d{7})$",
        "Languages": "es-NI,en",
        "geonameid": 3617476,
        "neighbours": "CR,HN",
        "EquivalentFipsCode": ""
    },
    "NL": {
        "ISO3": "NLD",
        "ISO-Numeric": 528,
        "fips": "NL",
        "Country": "Netherlands",
        "Capital": "Amsterdam",
        "Area(in sq km)": 41526,
        "Population": 16645000,
        "Continent": "EU",
        "tld": ".nl",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 31,
        "Postal Code Format": "#### @@",
        "Postal Code Regex": "^(\\d{4}[A-Z]{2})$",
        "Languages": "nl-NL,fy-NL",
        "geonameid": 2750405,
        "neighbours": "DE,BE",
        "EquivalentFipsCode": ""
    },
    "NO": {
        "ISO3": "NOR",
        "ISO-Numeric": 578,
        "fips": "NO",
        "Country": "Norway",
        "Capital": "Oslo",
        "Area(in sq km)": 324220,
        "Population": 5009150,
        "Continent": "EU",
        "tld": ".no",
        "CurrencyCode": "NOK",
        "CurrencyName": "Krone",
        "Phone": 47,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "no,nb,nn,se,fi",
        "geonameid": 3144096,
        "neighbours": "FI,RU,SE",
        "EquivalentFipsCode": ""
    },
    "NP": {
        "ISO3": "NPL",
        "ISO-Numeric": 524,
        "fips": "NP",
        "Country": "Nepal",
        "Capital": "Kathmandu",
        "Area(in sq km)": 140800,
        "Population": 28951852,
        "Continent": "AS",
        "tld": ".np",
        "CurrencyCode": "NPR",
        "CurrencyName": "Rupee",
        "Phone": 977,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ne,en",
        "geonameid": 1282988,
        "neighbours": "CN,IN",
        "EquivalentFipsCode": ""
    },
    "NR": {
        "ISO3": "NRU",
        "ISO-Numeric": 520,
        "fips": "NR",
        "Country": "Nauru",
        "Capital": "Yaren",
        "Area(in sq km)": 21,
        "Population": 10065,
        "Continent": "OC",
        "tld": ".nr",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 674,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "na,en-NR",
        "geonameid": 2110425,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "NU": {
        "ISO3": "NIU",
        "ISO-Numeric": 570,
        "fips": "NE",
        "Country": "Niue",
        "Capital": "Alofi",
        "Area(in sq km)": 260,
        "Population": 2166,
        "Continent": "OC",
        "tld": ".nu",
        "CurrencyCode": "NZD",
        "CurrencyName": "Dollar",
        "Phone": 683,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "niu,en-NU",
        "geonameid": 4036232,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "NZ": {
        "ISO3": "NZL",
        "ISO-Numeric": 554,
        "fips": "NZ",
        "Country": "New Zealand",
        "Capital": "Wellington",
        "Area(in sq km)": 268680,
        "Population": 4252277,
        "Continent": "OC",
        "tld": ".nz",
        "CurrencyCode": "NZD",
        "CurrencyName": "Dollar",
        "Phone": 64,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "en-NZ,mi",
        "geonameid": 2186224,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "OM": {
        "ISO3": "OMN",
        "ISO-Numeric": 512,
        "fips": "MU",
        "Country": "Oman",
        "Capital": "Muscat",
        "Area(in sq km)": 212460,
        "Population": 2967717,
        "Continent": "AS",
        "tld": ".om",
        "CurrencyCode": "OMR",
        "CurrencyName": "Rial",
        "Phone": 968,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(\\d{3})$",
        "Languages": "ar-OM,en,bal,ur",
        "geonameid": 286963,
        "neighbours": "SA,YE,AE",
        "EquivalentFipsCode": ""
    },
    "PA": {
        "ISO3": "PAN",
        "ISO-Numeric": 591,
        "fips": "PM",
        "Country": "Panama",
        "Capital": "Panama City",
        "Area(in sq km)": 78200,
        "Population": 3410676,
        "Continent": "NA",
        "tld": ".pa",
        "CurrencyCode": "PAB",
        "CurrencyName": "Balboa",
        "Phone": 507,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "es-PA,en",
        "geonameid": 3703430,
        "neighbours": "CR,CO",
        "EquivalentFipsCode": ""
    },
    "PE": {
        "ISO3": "PER",
        "ISO-Numeric": 604,
        "fips": "PE",
        "Country": "Peru",
        "Capital": "Lima",
        "Area(in sq km)": 1285220,
        "Population": 29907003,
        "Continent": "SA",
        "tld": ".pe",
        "CurrencyCode": "PEN",
        "CurrencyName": "Sol",
        "Phone": 51,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "es-PE,qu,ay",
        "geonameid": 3932488,
        "neighbours": "EC,CL,BO,BR,CO",
        "EquivalentFipsCode": ""
    },
    "PF": {
        "ISO3": "PYF",
        "ISO-Numeric": 258,
        "fips": "FP",
        "Country": "French Polynesia",
        "Capital": "Papeete",
        "Area(in sq km)": 4167,
        "Population": 270485,
        "Continent": "OC",
        "tld": ".pf",
        "CurrencyCode": "XPF",
        "CurrencyName": "Franc",
        "Phone": 689,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^((97|98)7\\d{2})$",
        "Languages": "fr-PF,ty",
        "geonameid": 4030656,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PG": {
        "ISO3": "PNG",
        "ISO-Numeric": 598,
        "fips": "PP",
        "Country": "Papua New Guinea",
        "Capital": "Port Moresby",
        "Area(in sq km)": 462840,
        "Population": 6064515,
        "Continent": "OC",
        "tld": ".pg",
        "CurrencyCode": "PGK",
        "CurrencyName": "Kina",
        "Phone": 675,
        "Postal Code Format": "###",
        "Postal Code Regex": "^(\\d{3})$",
        "Languages": "en-PG,ho,meu,tpi",
        "geonameid": 2088628,
        "neighbours": "ID",
        "EquivalentFipsCode": ""
    },
    "PH": {
        "ISO3": "PHL",
        "ISO-Numeric": 608,
        "fips": "RP",
        "Country": "Philippines",
        "Capital": "Manila",
        "Area(in sq km)": 300000,
        "Population": 99900177,
        "Continent": "AS",
        "tld": ".ph",
        "CurrencyCode": "PHP",
        "CurrencyName": "Peso",
        "Phone": 63,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "tl,en-PH,fil",
        "geonameid": 1694008,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PK": {
        "ISO3": "PAK",
        "ISO-Numeric": 586,
        "fips": "PK",
        "Country": "Pakistan",
        "Capital": "Islamabad",
        "Area(in sq km)": 803940,
        "Population": 184404791,
        "Continent": "AS",
        "tld": ".pk",
        "CurrencyCode": "PKR",
        "CurrencyName": "Rupee",
        "Phone": 92,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ur-PK,en-PK,pa,sd,ps,brh",
        "geonameid": 1168579,
        "neighbours": "CN,AF,IR,IN",
        "EquivalentFipsCode": ""
    },
    "PL": {
        "ISO3": "POL",
        "ISO-Numeric": 616,
        "fips": "PL",
        "Country": "Poland",
        "Capital": "Warsaw",
        "Area(in sq km)": 312685,
        "Population": 38500000,
        "Continent": "EU",
        "tld": ".pl",
        "CurrencyCode": "PLN",
        "CurrencyName": "Zloty",
        "Phone": 48,
        "Postal Code Format": "##-###",
        "Postal Code Regex": "^\\d{2}-\\d{3}$",
        "Languages": "pl",
        "geonameid": 798544,
        "neighbours": "DE,LT,SK,CZ,BY,UA,RU",
        "EquivalentFipsCode": ""
    },
    "PM": {
        "ISO3": "SPM",
        "ISO-Numeric": 666,
        "fips": "SB",
        "Country": "Saint Pierre and Miquelon",
        "Capital": "Saint-Pierre",
        "Area(in sq km)": 242,
        "Population": 7012,
        "Continent": "NA",
        "tld": ".pm",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 508,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(97500)$",
        "Languages": "fr-PM",
        "geonameid": 3424932,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PN": {
        "ISO3": "PCN",
        "ISO-Numeric": 612,
        "fips": "PC",
        "Country": "Pitcairn",
        "Capital": "Adamstown",
        "Area(in sq km)": 47,
        "Population": 46,
        "Continent": "OC",
        "tld": ".pn",
        "CurrencyCode": "NZD",
        "CurrencyName": "Dollar",
        "Phone": 870,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-PN",
        "geonameid": 4030699,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PR": {
        "ISO3": "PRI",
        "ISO-Numeric": 630,
        "fips": "RQ",
        "Country": "Puerto Rico",
        "Capital": "San Juan",
        "Area(in sq km)": 9104,
        "Population": 3916632,
        "Continent": "NA",
        "tld": ".pr",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-787 and 1-939",
        "Postal Code Format": "#####-####",
        "Postal Code Regex": "^00[679]\\d{2}(?:-\\d{4})?$",
        "Languages": "en-PR,es-PR",
        "geonameid": 4566966,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PS": {
        "ISO3": "PSE",
        "ISO-Numeric": 275,
        "fips": "WE",
        "Country": "Palestinian Territory",
        "Capital": "East Jerusalem",
        "Area(in sq km)": 5970,
        "Population": 3800000,
        "Continent": "AS",
        "tld": ".ps",
        "CurrencyCode": "ILS",
        "CurrencyName": "Shekel",
        "Phone": 970,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-PS",
        "geonameid": 6254930,
        "neighbours": "JO,IL,EG",
        "EquivalentFipsCode": ""
    },
    "PT": {
        "ISO3": "PRT",
        "ISO-Numeric": 620,
        "fips": "PO",
        "Country": "Portugal",
        "Capital": "Lisbon",
        "Area(in sq km)": 92391,
        "Population": 10676000,
        "Continent": "EU",
        "tld": ".pt",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 351,
        "Postal Code Format": "####-###",
        "Postal Code Regex": "^\\d{4}-\\d{3}\\s?[a-zA-Z]{0,25}$",
        "Languages": "pt-PT,mwl",
        "geonameid": 2264397,
        "neighbours": "ES",
        "EquivalentFipsCode": ""
    },
    "PW": {
        "ISO3": "PLW",
        "ISO-Numeric": 585,
        "fips": "PS",
        "Country": "Palau",
        "Capital": "Melekeok",
        "Area(in sq km)": 458,
        "Population": 19907,
        "Continent": "OC",
        "tld": ".pw",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 680,
        "Postal Code Format": 96940,
        "Postal Code Regex": "^(96940)$",
        "Languages": "pau,sov,en-PW,tox,ja,fil,zh",
        "geonameid": 1559582,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "PY": {
        "ISO3": "PRY",
        "ISO-Numeric": 600,
        "fips": "PA",
        "Country": "Paraguay",
        "Capital": "Asuncion",
        "Area(in sq km)": 406750,
        "Population": 6375830,
        "Continent": "SA",
        "tld": ".py",
        "CurrencyCode": "PYG",
        "CurrencyName": "Guarani",
        "Phone": 595,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "es-PY,gn",
        "geonameid": 3437598,
        "neighbours": "BO,BR,AR",
        "EquivalentFipsCode": ""
    },
    "QA": {
        "ISO3": "QAT",
        "ISO-Numeric": 634,
        "fips": "QA",
        "Country": "Qatar",
        "Capital": "Doha",
        "Area(in sq km)": 11437,
        "Population": 840926,
        "Continent": "AS",
        "tld": ".qa",
        "CurrencyCode": "QAR",
        "CurrencyName": "Rial",
        "Phone": 974,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-QA,es",
        "geonameid": 289688,
        "neighbours": "SA",
        "EquivalentFipsCode": ""
    },
    "RE": {
        "ISO3": "REU",
        "ISO-Numeric": 638,
        "fips": "RE",
        "Country": "Reunion",
        "Capital": "Saint-Denis",
        "Area(in sq km)": 2517,
        "Population": 776948,
        "Continent": "AF",
        "tld": ".re",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 262,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^((97|98)(4|7|8)\\d{2})$",
        "Languages": "fr-RE",
        "geonameid": 935317,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "RO": {
        "ISO3": "ROU",
        "ISO-Numeric": 642,
        "fips": "RO",
        "Country": "Romania",
        "Capital": "Bucharest",
        "Area(in sq km)": 237500,
        "Population": 21959278,
        "Continent": "EU",
        "tld": ".ro",
        "CurrencyCode": "RON",
        "CurrencyName": "Leu",
        "Phone": 40,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "ro,hu,rom",
        "geonameid": 798549,
        "neighbours": "MD,HU,UA,BG,RS",
        "EquivalentFipsCode": ""
    },
    "RS": {
        "ISO3": "SRB",
        "ISO-Numeric": 688,
        "fips": "RI",
        "Country": "Serbia",
        "Capital": "Belgrade",
        "Area(in sq km)": 88361,
        "Population": 7344847,
        "Continent": "EU",
        "tld": ".rs",
        "CurrencyCode": "RSD",
        "CurrencyName": "Dinar",
        "Phone": 381,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "sr,hu,bs,rom",
        "geonameid": 6290252,
        "neighbours": "AL,HU,MK,RO,HR,BA,BG,ME,XK",
        "EquivalentFipsCode": ""
    },
    "RU": {
        "ISO3": "RUS",
        "ISO-Numeric": 643,
        "fips": "RS",
        "Country": "Russia",
        "Capital": "Moscow",
        "Area(in sq km)": 17100000,
        "Population": 140702000,
        "Continent": "EU",
        "tld": ".ru",
        "CurrencyCode": "RUB",
        "CurrencyName": "Ruble",
        "Phone": 7,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "ru,tt,xal,cau,ady,kv,ce,tyv,cv,udm,tut,mns,bua,myv,mdf,chm,ba,inh,tut,kbd,krc,av,sah,nog",
        "geonameid": 2017370,
        "neighbours": "GE,CN,BY,UA,KZ,LV,PL,EE,LT,FI,MN,NO,AZ,KP",
        "EquivalentFipsCode": ""
    },
    "RW": {
        "ISO3": "RWA",
        "ISO-Numeric": 646,
        "fips": "RW",
        "Country": "Rwanda",
        "Capital": "Kigali",
        "Area(in sq km)": 26338,
        "Population": 11055976,
        "Continent": "AF",
        "tld": ".rw",
        "CurrencyCode": "RWF",
        "CurrencyName": "Franc",
        "Phone": 250,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "rw,en-RW,fr-RW,sw",
        "geonameid": 49518,
        "neighbours": "TZ,CD,BI,UG",
        "EquivalentFipsCode": ""
    },
    "SA": {
        "ISO3": "SAU",
        "ISO-Numeric": 682,
        "fips": "SA",
        "Country": "Saudi Arabia",
        "Capital": "Riyadh",
        "Area(in sq km)": 1960582,
        "Population": 25731776,
        "Continent": "AS",
        "tld": ".sa",
        "CurrencyCode": "SAR",
        "CurrencyName": "Rial",
        "Phone": 966,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-SA",
        "geonameid": 102358,
        "neighbours": "QA,OM,IQ,YE,JO,AE,KW",
        "EquivalentFipsCode": ""
    },
    "SB": {
        "ISO3": "SLB",
        "ISO-Numeric": 90,
        "fips": "BP",
        "Country": "Solomon Islands",
        "Capital": "Honiara",
        "Area(in sq km)": 28450,
        "Population": 559198,
        "Continent": "OC",
        "tld": ".sb",
        "CurrencyCode": "SBD",
        "CurrencyName": "Dollar",
        "Phone": 677,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-SB,tpi",
        "geonameid": 2103350,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SC": {
        "ISO3": "SYC",
        "ISO-Numeric": 690,
        "fips": "SE",
        "Country": "Seychelles",
        "Capital": "Victoria",
        "Area(in sq km)": 455,
        "Population": 88340,
        "Continent": "AF",
        "tld": ".sc",
        "CurrencyCode": "SCR",
        "CurrencyName": "Rupee",
        "Phone": 248,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-SC,fr-SC",
        "geonameid": 241170,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SD": {
        "ISO3": "SDN",
        "ISO-Numeric": 729,
        "fips": "SU",
        "Country": "Sudan",
        "Capital": "Khartoum",
        "Area(in sq km)": 1861484,
        "Population": 35000000,
        "Continent": "AF",
        "tld": ".sd",
        "CurrencyCode": "SDG",
        "CurrencyName": "Pound",
        "Phone": 249,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "ar-SD,en,fia",
        "geonameid": 366755,
        "neighbours": "SS,TD,EG,ET,ER,LY,CF",
        "EquivalentFipsCode": ""
    },
    "SS": {
        "ISO3": "SSD",
        "ISO-Numeric": 728,
        "fips": "OD",
        "Country": "South Sudan",
        "Capital": "Juba",
        "Area(in sq km)": 644329,
        "Population": 8260490,
        "Continent": "AF",
        "tld": "",
        "CurrencyCode": "SSP",
        "CurrencyName": "Pound",
        "Phone": 211,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en",
        "geonameid": 7909807,
        "neighbours": "CD,CF,ET,KE,SD,UG",
        "EquivalentFipsCode": ""
    },
    "SE": {
        "ISO3": "SWE",
        "ISO-Numeric": 752,
        "fips": "SW",
        "Country": "Sweden",
        "Capital": "Stockholm",
        "Area(in sq km)": 449964,
        "Population": 9828655,
        "Continent": "EU",
        "tld": ".se",
        "CurrencyCode": "SEK",
        "CurrencyName": "Krona",
        "Phone": 46,
        "Postal Code Format": "### ##",
        "Postal Code Regex": "^(?:SE)?\\d{3}\\s\\d{2}$",
        "Languages": "sv-SE,se,sma,fi-SE",
        "geonameid": 2661886,
        "neighbours": "NO,FI",
        "EquivalentFipsCode": ""
    },
    "SG": {
        "ISO3": "SGP",
        "ISO-Numeric": 702,
        "fips": "SN",
        "Country": "Singapore",
        "Capital": "Singapore",
        "Area(in sq km)": 692.7,
        "Population": 4701069,
        "Continent": "AS",
        "tld": ".sg",
        "CurrencyCode": "SGD",
        "CurrencyName": "Dollar",
        "Phone": 65,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "cmn,en-SG,ms-SG,ta-SG,zh-SG",
        "geonameid": 1880251,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SH": {
        "ISO3": "SHN",
        "ISO-Numeric": 654,
        "fips": "SH",
        "Country": "Saint Helena",
        "Capital": "Jamestown",
        "Area(in sq km)": 410,
        "Population": 7460,
        "Continent": "AF",
        "tld": ".sh",
        "CurrencyCode": "SHP",
        "CurrencyName": "Pound",
        "Phone": 290,
        "Postal Code Format": "STHL 1ZZ",
        "Postal Code Regex": "^(STHL1ZZ)$",
        "Languages": "en-SH",
        "geonameid": 3370751,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SI": {
        "ISO3": "SVN",
        "ISO-Numeric": 705,
        "fips": "SI",
        "Country": "Slovenia",
        "Capital": "Ljubljana",
        "Area(in sq km)": 20273,
        "Population": 2007000,
        "Continent": "EU",
        "tld": ".si",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 386,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(?:SI)*(\\d{4})$",
        "Languages": "sl,sh",
        "geonameid": 3190538,
        "neighbours": "HU,IT,HR,AT",
        "EquivalentFipsCode": ""
    },
    "SJ": {
        "ISO3": "SJM",
        "ISO-Numeric": 744,
        "fips": "SV",
        "Country": "Svalbard and Jan Mayen",
        "Capital": "Longyearbyen",
        "Area(in sq km)": 62049,
        "Population": 2550,
        "Continent": "EU",
        "tld": ".sj",
        "CurrencyCode": "NOK",
        "CurrencyName": "Krone",
        "Phone": 47,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "no,ru",
        "geonameid": 607072,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SK": {
        "ISO3": "SVK",
        "ISO-Numeric": 703,
        "fips": "LO",
        "Country": "Slovakia",
        "Capital": "Bratislava",
        "Area(in sq km)": 48845,
        "Population": 5455000,
        "Continent": "EU",
        "tld": ".sk",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 421,
        "Postal Code Format": "### ##",
        "Postal Code Regex": "^\\d{3}\\s?\\d{2}$",
        "Languages": "sk,hu",
        "geonameid": 3057568,
        "neighbours": "PL,HU,CZ,UA,AT",
        "EquivalentFipsCode": ""
    },
    "SL": {
        "ISO3": "SLE",
        "ISO-Numeric": 694,
        "fips": "SL",
        "Country": "Sierra Leone",
        "Capital": "Freetown",
        "Area(in sq km)": 71740,
        "Population": 5245695,
        "Continent": "AF",
        "tld": ".sl",
        "CurrencyCode": "SLL",
        "CurrencyName": "Leone",
        "Phone": 232,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-SL,men,tem",
        "geonameid": 2403846,
        "neighbours": "LR,GN",
        "EquivalentFipsCode": ""
    },
    "SM": {
        "ISO3": "SMR",
        "ISO-Numeric": 674,
        "fips": "SM",
        "Country": "San Marino",
        "Capital": "San Marino",
        "Area(in sq km)": 61.2,
        "Population": 31477,
        "Continent": "EU",
        "tld": ".sm",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 378,
        "Postal Code Format": "4789#",
        "Postal Code Regex": "^(4789\\d)$",
        "Languages": "it-SM",
        "geonameid": 3168068,
        "neighbours": "IT",
        "EquivalentFipsCode": ""
    },
    "SN": {
        "ISO3": "SEN",
        "ISO-Numeric": 686,
        "fips": "SG",
        "Country": "Senegal",
        "Capital": "Dakar",
        "Area(in sq km)": 196190,
        "Population": 12323252,
        "Continent": "AF",
        "tld": ".sn",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 221,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-SN,wo,fuc,mnk",
        "geonameid": 2245662,
        "neighbours": "GN,MR,GW,GM,ML",
        "EquivalentFipsCode": ""
    },
    "SO": {
        "ISO3": "SOM",
        "ISO-Numeric": 706,
        "fips": "SO",
        "Country": "Somalia",
        "Capital": "Mogadishu",
        "Area(in sq km)": 637657,
        "Population": 10112453,
        "Continent": "AF",
        "tld": ".so",
        "CurrencyCode": "SOS",
        "CurrencyName": "Shilling",
        "Phone": 252,
        "Postal Code Format": "@@  #####",
        "Postal Code Regex": "^([A-Z]{2}\\d{5})$",
        "Languages": "so-SO,ar-SO,it,en-SO",
        "geonameid": 51537,
        "neighbours": "ET,KE,DJ",
        "EquivalentFipsCode": ""
    },
    "SR": {
        "ISO3": "SUR",
        "ISO-Numeric": 740,
        "fips": "NS",
        "Country": "Suriname",
        "Capital": "Paramaribo",
        "Area(in sq km)": 163270,
        "Population": 492829,
        "Continent": "SA",
        "tld": ".sr",
        "CurrencyCode": "SRD",
        "CurrencyName": "Dollar",
        "Phone": 597,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl-SR,en,srn,hns,jv",
        "geonameid": 3382998,
        "neighbours": "GY,BR,GF",
        "EquivalentFipsCode": ""
    },
    "ST": {
        "ISO3": "STP",
        "ISO-Numeric": 678,
        "fips": "TP",
        "Country": "Sao Tome and Principe",
        "Capital": "Sao Tome",
        "Area(in sq km)": 1001,
        "Population": 175808,
        "Continent": "AF",
        "tld": ".st",
        "CurrencyCode": "STD",
        "CurrencyName": "Dobra",
        "Phone": 239,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "pt-ST",
        "geonameid": 2410758,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "SV": {
        "ISO3": "SLV",
        "ISO-Numeric": 222,
        "fips": "ES",
        "Country": "El Salvador",
        "Capital": "San Salvador",
        "Area(in sq km)": 21040,
        "Population": 6052064,
        "Continent": "NA",
        "tld": ".sv",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 503,
        "Postal Code Format": "CP ####",
        "Postal Code Regex": "^(?:CP)*(\\d{4})$",
        "Languages": "es-SV",
        "geonameid": 3585968,
        "neighbours": "GT,HN",
        "EquivalentFipsCode": ""
    },
    "SX": {
        "ISO3": "SXM",
        "ISO-Numeric": 534,
        "fips": "NN",
        "Country": "Sint Maarten",
        "Capital": "Philipsburg",
        "Area(in sq km)": 21,
        "Population": 37429,
        "Continent": "NA",
        "tld": ".sx",
        "CurrencyCode": "ANG",
        "CurrencyName": "Guilder",
        "Phone": 599,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl,en",
        "geonameid": 7609695,
        "neighbours": "MF",
        "EquivalentFipsCode": ""
    },
    "SY": {
        "ISO3": "SYR",
        "ISO-Numeric": 760,
        "fips": "SY",
        "Country": "Syria",
        "Capital": "Damascus",
        "Area(in sq km)": 185180,
        "Population": 22198110,
        "Continent": "AS",
        "tld": ".sy",
        "CurrencyCode": "SYP",
        "CurrencyName": "Pound",
        "Phone": 963,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-SY,ku,hy,arc,fr,en",
        "geonameid": 163843,
        "neighbours": "IQ,JO,IL,TR,LB",
        "EquivalentFipsCode": ""
    },
    "SZ": {
        "ISO3": "SWZ",
        "ISO-Numeric": 748,
        "fips": "WZ",
        "Country": "Swaziland",
        "Capital": "Mbabane",
        "Area(in sq km)": 17363,
        "Population": 1354051,
        "Continent": "AF",
        "tld": ".sz",
        "CurrencyCode": "SZL",
        "CurrencyName": "Lilangeni",
        "Phone": 268,
        "Postal Code Format": "@###",
        "Postal Code Regex": "^([A-Z]\\d{3})$",
        "Languages": "en-SZ,ss-SZ",
        "geonameid": 934841,
        "neighbours": "ZA,MZ",
        "EquivalentFipsCode": ""
    },
    "TC": {
        "ISO3": "TCA",
        "ISO-Numeric": 796,
        "fips": "TK",
        "Country": "Turks and Caicos Islands",
        "Capital": "Cockburn Town",
        "Area(in sq km)": 430,
        "Population": 20556,
        "Continent": "NA",
        "tld": ".tc",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-649",
        "Postal Code Format": "TKCA 1ZZ",
        "Postal Code Regex": "^(TKCA 1ZZ)$",
        "Languages": "en-TC",
        "geonameid": 3576916,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TD": {
        "ISO3": "TCD",
        "ISO-Numeric": 148,
        "fips": "CD",
        "Country": "Chad",
        "Capital": "N'Djamena",
        "Area(in sq km)": 1284000,
        "Population": 10543464,
        "Continent": "AF",
        "tld": ".td",
        "CurrencyCode": "XAF",
        "CurrencyName": "Franc",
        "Phone": 235,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-TD,ar-TD,sre",
        "geonameid": 2434508,
        "neighbours": "NE,LY,CF,SD,CM,NG",
        "EquivalentFipsCode": ""
    },
    "TF": {
        "ISO3": "ATF",
        "ISO-Numeric": 260,
        "fips": "FS",
        "Country": "French Southern Territories",
        "Capital": "Port-aux-Francais",
        "Area(in sq km)": 7829,
        "Population": 140,
        "Continent": "AN",
        "tld": ".tf",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": "",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr",
        "geonameid": 1546748,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TG": {
        "ISO3": "TGO",
        "ISO-Numeric": 768,
        "fips": "TO",
        "Country": "Togo",
        "Capital": "Lome",
        "Area(in sq km)": 56785,
        "Population": 6587239,
        "Continent": "AF",
        "tld": ".tg",
        "CurrencyCode": "XOF",
        "CurrencyName": "Franc",
        "Phone": 228,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "fr-TG,ee,hna,kbp,dag,ha",
        "geonameid": 2363686,
        "neighbours": "BJ,GH,BF",
        "EquivalentFipsCode": ""
    },
    "TH": {
        "ISO3": "THA",
        "ISO-Numeric": 764,
        "fips": "TH",
        "Country": "Thailand",
        "Capital": "Bangkok",
        "Area(in sq km)": 514000,
        "Population": 67089500,
        "Continent": "AS",
        "tld": ".th",
        "CurrencyCode": "THB",
        "CurrencyName": "Baht",
        "Phone": 66,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "th,en",
        "geonameid": 1605651,
        "neighbours": "LA,MM,KH,MY",
        "EquivalentFipsCode": ""
    },
    "TJ": {
        "ISO3": "TJK",
        "ISO-Numeric": 762,
        "fips": "TI",
        "Country": "Tajikistan",
        "Capital": "Dushanbe",
        "Area(in sq km)": 143100,
        "Population": 7487489,
        "Continent": "AS",
        "tld": ".tj",
        "CurrencyCode": "TJS",
        "CurrencyName": "Somoni",
        "Phone": 992,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "tg,ru",
        "geonameid": 1220409,
        "neighbours": "CN,AF,KG,UZ",
        "EquivalentFipsCode": ""
    },
    "TK": {
        "ISO3": "TKL",
        "ISO-Numeric": 772,
        "fips": "TL",
        "Country": "Tokelau",
        "Capital": "",
        "Area(in sq km)": 10,
        "Population": 1466,
        "Continent": "OC",
        "tld": ".tk",
        "CurrencyCode": "NZD",
        "CurrencyName": "Dollar",
        "Phone": 690,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "tkl,en-TK",
        "geonameid": 4031074,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TL": {
        "ISO3": "TLS",
        "ISO-Numeric": 626,
        "fips": "TT",
        "Country": "East Timor",
        "Capital": "Dili",
        "Area(in sq km)": 15007,
        "Population": 1154625,
        "Continent": "OC",
        "tld": ".tl",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 670,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "tet,pt-TL,id,en",
        "geonameid": 1966436,
        "neighbours": "ID",
        "EquivalentFipsCode": ""
    },
    "TM": {
        "ISO3": "TKM",
        "ISO-Numeric": 795,
        "fips": "TX",
        "Country": "Turkmenistan",
        "Capital": "Ashgabat",
        "Area(in sq km)": 488100,
        "Population": 4940916,
        "Continent": "AS",
        "tld": ".tm",
        "CurrencyCode": "TMT",
        "CurrencyName": "Manat",
        "Phone": 993,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "tk,ru,uz",
        "geonameid": 1218197,
        "neighbours": "AF,IR,UZ,KZ",
        "EquivalentFipsCode": ""
    },
    "TN": {
        "ISO3": "TUN",
        "ISO-Numeric": 788,
        "fips": "TS",
        "Country": "Tunisia",
        "Capital": "Tunis",
        "Area(in sq km)": 163610,
        "Population": 10589025,
        "Continent": "AF",
        "tld": ".tn",
        "CurrencyCode": "TND",
        "CurrencyName": "Dinar",
        "Phone": 216,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "ar-TN,fr",
        "geonameid": 2464461,
        "neighbours": "DZ,LY",
        "EquivalentFipsCode": ""
    },
    "TO": {
        "ISO3": "TON",
        "ISO-Numeric": 776,
        "fips": "TN",
        "Country": "Tonga",
        "Capital": "Nuku'alofa",
        "Area(in sq km)": 748,
        "Population": 122580,
        "Continent": "OC",
        "tld": ".to",
        "CurrencyCode": "TOP",
        "CurrencyName": "Pa'anga",
        "Phone": 676,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "to,en-TO",
        "geonameid": 4032283,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TR": {
        "ISO3": "TUR",
        "ISO-Numeric": 792,
        "fips": "TU",
        "Country": "Turkey",
        "Capital": "Ankara",
        "Area(in sq km)": 780580,
        "Population": 77804122,
        "Continent": "AS",
        "tld": ".tr",
        "CurrencyCode": "TRY",
        "CurrencyName": "Lira",
        "Phone": 90,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "tr-TR,ku,diq,az,av",
        "geonameid": 298795,
        "neighbours": "SY,GE,IQ,IR,GR,AM,AZ,BG",
        "EquivalentFipsCode": ""
    },
    "TT": {
        "ISO3": "TTO",
        "ISO-Numeric": 780,
        "fips": "TD",
        "Country": "Trinidad and Tobago",
        "Capital": "Port of Spain",
        "Area(in sq km)": 5128,
        "Population": 1228691,
        "Continent": "NA",
        "tld": ".tt",
        "CurrencyCode": "TTD",
        "CurrencyName": "Dollar",
        "Phone": "+1-868",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-TT,hns,fr,es,zh",
        "geonameid": 3573591,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TV": {
        "ISO3": "TUV",
        "ISO-Numeric": 798,
        "fips": "TV",
        "Country": "Tuvalu",
        "Capital": "Funafuti",
        "Area(in sq km)": 26,
        "Population": 10472,
        "Continent": "OC",
        "tld": ".tv",
        "CurrencyCode": "AUD",
        "CurrencyName": "Dollar",
        "Phone": 688,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "tvl,en,sm,gil",
        "geonameid": 2110297,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TW": {
        "ISO3": "TWN",
        "ISO-Numeric": 158,
        "fips": "TW",
        "Country": "Taiwan",
        "Capital": "Taipei",
        "Area(in sq km)": 35980,
        "Population": 22894384,
        "Continent": "AS",
        "tld": ".tw",
        "CurrencyCode": "TWD",
        "CurrencyName": "Dollar",
        "Phone": 886,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "zh-TW,zh,nan,hak",
        "geonameid": 1668284,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "TZ": {
        "ISO3": "TZA",
        "ISO-Numeric": 834,
        "fips": "TZ",
        "Country": "Tanzania",
        "Capital": "Dodoma",
        "Area(in sq km)": 945087,
        "Population": 41892895,
        "Continent": "AF",
        "tld": ".tz",
        "CurrencyCode": "TZS",
        "CurrencyName": "Shilling",
        "Phone": 255,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "sw-TZ,en,ar",
        "geonameid": 149590,
        "neighbours": "MZ,KE,CD,RW,ZM,BI,UG,MW",
        "EquivalentFipsCode": ""
    },
    "UA": {
        "ISO3": "UKR",
        "ISO-Numeric": 804,
        "fips": "UP",
        "Country": "Ukraine",
        "Capital": "Kiev",
        "Area(in sq km)": 603700,
        "Population": 45415596,
        "Continent": "EU",
        "tld": ".ua",
        "CurrencyCode": "UAH",
        "CurrencyName": "Hryvnia",
        "Phone": 380,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "uk,ru-UA,rom,pl,hu",
        "geonameid": 690791,
        "neighbours": "PL,MD,HU,SK,BY,RO,RU",
        "EquivalentFipsCode": ""
    },
    "UG": {
        "ISO3": "UGA",
        "ISO-Numeric": 800,
        "fips": "UG",
        "Country": "Uganda",
        "Capital": "Kampala",
        "Area(in sq km)": 236040,
        "Population": 33398682,
        "Continent": "AF",
        "tld": ".ug",
        "CurrencyCode": "UGX",
        "CurrencyName": "Shilling",
        "Phone": 256,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-UG,lg,sw,ar",
        "geonameid": 226074,
        "neighbours": "TZ,KE,SS,CD,RW",
        "EquivalentFipsCode": ""
    },
    "UM": {
        "ISO3": "UMI",
        "ISO-Numeric": 581,
        "fips": "",
        "Country": "United States Minor Outlying Islands",
        "Capital": "",
        "Area(in sq km)": 0,
        "Population": 0,
        "Continent": "OC",
        "tld": ".um",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 1,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-UM",
        "geonameid": 5854968,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "US": {
        "ISO3": "USA",
        "ISO-Numeric": 840,
        "fips": "US",
        "Country": "United States",
        "Capital": "Washington",
        "Area(in sq km)": 9629091,
        "Population": 310232863,
        "Continent": "NA",
        "tld": ".us",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": 1,
        "Postal Code Format": "#####-####",
        "Postal Code Regex": "^\\d{5}(-\\d{4})?$",
        "Languages": "en-US,es-US,haw,fr",
        "geonameid": 6252001,
        "neighbours": "CA,MX,CU",
        "EquivalentFipsCode": ""
    },
    "UY": {
        "ISO3": "URY",
        "ISO-Numeric": 858,
        "fips": "UY",
        "Country": "Uruguay",
        "Capital": "Montevideo",
        "Area(in sq km)": 176220,
        "Population": 3477000,
        "Continent": "SA",
        "tld": ".uy",
        "CurrencyCode": "UYU",
        "CurrencyName": "Peso",
        "Phone": 598,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "es-UY",
        "geonameid": 3439705,
        "neighbours": "BR,AR",
        "EquivalentFipsCode": ""
    },
    "UZ": {
        "ISO3": "UZB",
        "ISO-Numeric": 860,
        "fips": "UZ",
        "Country": "Uzbekistan",
        "Capital": "Tashkent",
        "Area(in sq km)": 447400,
        "Population": 27865738,
        "Continent": "AS",
        "tld": ".uz",
        "CurrencyCode": "UZS",
        "CurrencyName": "Som",
        "Phone": 998,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "uz,ru,tg",
        "geonameid": 1512440,
        "neighbours": "TM,AF,KG,TJ,KZ",
        "EquivalentFipsCode": ""
    },
    "VA": {
        "ISO3": "VAT",
        "ISO-Numeric": 336,
        "fips": "VT",
        "Country": "Vatican",
        "Capital": "Vatican City",
        "Area(in sq km)": 0.44,
        "Population": 921,
        "Continent": "EU",
        "tld": ".va",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 379,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "la,it,fr",
        "geonameid": 3164670,
        "neighbours": "IT",
        "EquivalentFipsCode": ""
    },
    "VC": {
        "ISO3": "VCT",
        "ISO-Numeric": 670,
        "fips": "VC",
        "Country": "Saint Vincent and the Grenadines",
        "Capital": "Kingstown",
        "Area(in sq km)": 389,
        "Population": 104217,
        "Continent": "NA",
        "tld": ".vc",
        "CurrencyCode": "XCD",
        "CurrencyName": "Dollar",
        "Phone": "+1-784",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-VC,fr",
        "geonameid": 3577815,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "VE": {
        "ISO3": "VEN",
        "ISO-Numeric": 862,
        "fips": "VE",
        "Country": "Venezuela",
        "Capital": "Caracas",
        "Area(in sq km)": 912050,
        "Population": 27223228,
        "Continent": "SA",
        "tld": ".ve",
        "CurrencyCode": "VEF",
        "CurrencyName": "Bolivar",
        "Phone": 58,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "es-VE",
        "geonameid": 3625428,
        "neighbours": "GY,BR,CO",
        "EquivalentFipsCode": ""
    },
    "VG": {
        "ISO3": "VGB",
        "ISO-Numeric": 92,
        "fips": "VI",
        "Country": "British Virgin Islands",
        "Capital": "Road Town",
        "Area(in sq km)": 153,
        "Population": 21730,
        "Continent": "NA",
        "tld": ".vg",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-284",
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-VG",
        "geonameid": 3577718,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "VI": {
        "ISO3": "VIR",
        "ISO-Numeric": 850,
        "fips": "VQ",
        "Country": "U.S. Virgin Islands",
        "Capital": "Charlotte Amalie",
        "Area(in sq km)": 352,
        "Population": 108708,
        "Continent": "NA",
        "tld": ".vi",
        "CurrencyCode": "USD",
        "CurrencyName": "Dollar",
        "Phone": "+1-340",
        "Postal Code Format": "#####-####",
        "Postal Code Regex": "^008\\d{2}(?:-\\d{4})?$",
        "Languages": "en-VI",
        "geonameid": 4796775,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "VN": {
        "ISO3": "VNM",
        "ISO-Numeric": 704,
        "fips": "VM",
        "Country": "Vietnam",
        "Capital": "Hanoi",
        "Area(in sq km)": 329560,
        "Population": 89571130,
        "Continent": "AS",
        "tld": ".vn",
        "CurrencyCode": "VND",
        "CurrencyName": "Dong",
        "Phone": 84,
        "Postal Code Format": "######",
        "Postal Code Regex": "^(\\d{6})$",
        "Languages": "vi,en,fr,zh,km",
        "geonameid": 1562822,
        "neighbours": "CN,LA,KH",
        "EquivalentFipsCode": ""
    },
    "VU": {
        "ISO3": "VUT",
        "ISO-Numeric": 548,
        "fips": "NH",
        "Country": "Vanuatu",
        "Capital": "Port Vila",
        "Area(in sq km)": 12200,
        "Population": 221552,
        "Continent": "OC",
        "tld": ".vu",
        "CurrencyCode": "VUV",
        "CurrencyName": "Vatu",
        "Phone": 678,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "bi,en-VU,fr-VU",
        "geonameid": 2134431,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "WF": {
        "ISO3": "WLF",
        "ISO-Numeric": 876,
        "fips": "WF",
        "Country": "Wallis and Futuna",
        "Capital": "Mata Utu",
        "Area(in sq km)": 274,
        "Population": 16025,
        "Continent": "OC",
        "tld": ".wf",
        "CurrencyCode": "XPF",
        "CurrencyName": "Franc",
        "Phone": 681,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(986\\d{2})$",
        "Languages": "wls,fud,fr-WF",
        "geonameid": 4034749,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "WS": {
        "ISO3": "WSM",
        "ISO-Numeric": 882,
        "fips": "WS",
        "Country": "Samoa",
        "Capital": "Apia",
        "Area(in sq km)": 2944,
        "Population": 192001,
        "Continent": "OC",
        "tld": ".ws",
        "CurrencyCode": "WST",
        "CurrencyName": "Tala",
        "Phone": 685,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "sm,en-WS",
        "geonameid": 4034894,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "YE": {
        "ISO3": "YEM",
        "ISO-Numeric": 887,
        "fips": "YM",
        "Country": "Yemen",
        "Capital": "Sanaa",
        "Area(in sq km)": 527970,
        "Population": 23495361,
        "Continent": "AS",
        "tld": ".ye",
        "CurrencyCode": "YER",
        "CurrencyName": "Rial",
        "Phone": 967,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "ar-YE",
        "geonameid": 69543,
        "neighbours": "SA,OM",
        "EquivalentFipsCode": ""
    },
    "YT": {
        "ISO3": "MYT",
        "ISO-Numeric": 175,
        "fips": "MF",
        "Country": "Mayotte",
        "Capital": "Mamoudzou",
        "Area(in sq km)": 374,
        "Population": 159042,
        "Continent": "AF",
        "tld": ".yt",
        "CurrencyCode": "EUR",
        "CurrencyName": "Euro",
        "Phone": 262,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "fr-YT",
        "geonameid": 1024031,
        "neighbours": "",
        "EquivalentFipsCode": ""
    },
    "ZA": {
        "ISO3": "ZAF",
        "ISO-Numeric": 710,
        "fips": "SF",
        "Country": "South Africa",
        "Capital": "Pretoria",
        "Area(in sq km)": 1219912,
        "Population": 49000000,
        "Continent": "AF",
        "tld": ".za",
        "CurrencyCode": "ZAR",
        "CurrencyName": "Rand",
        "Phone": 27,
        "Postal Code Format": "####",
        "Postal Code Regex": "^(\\d{4})$",
        "Languages": "zu,xh,af,nso,en-ZA,tn,st,ts,ss,ve,nr",
        "geonameid": 953987,
        "neighbours": "ZW,SZ,MZ,BW,NA,LS",
        "EquivalentFipsCode": ""
    },
    "ZM": {
        "ISO3": "ZMB",
        "ISO-Numeric": 894,
        "fips": "ZA",
        "Country": "Zambia",
        "Capital": "Lusaka",
        "Area(in sq km)": 752614,
        "Population": 13460305,
        "Continent": "AF",
        "tld": ".zm",
        "CurrencyCode": "ZMW",
        "CurrencyName": "Kwacha",
        "Phone": 260,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "en-ZM,bem,loz,lun,lue,ny,toi",
        "geonameid": 895949,
        "neighbours": "ZW,TZ,MZ,CD,NA,MW,AO",
        "EquivalentFipsCode": ""
    },
    "ZW": {
        "ISO3": "ZWE",
        "ISO-Numeric": 716,
        "fips": "ZI",
        "Country": "Zimbabwe",
        "Capital": "Harare",
        "Area(in sq km)": 390580,
        "Population": 13061000,
        "Continent": "AF",
        "tld": ".zw",
        "CurrencyCode": "ZWL",
        "CurrencyName": "Dollar",
        "Phone": 263,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "en-ZW,sn,nr,nd",
        "geonameid": 878675,
        "neighbours": "ZA,MZ,BW,ZM",
        "EquivalentFipsCode": ""
    },
    "CS": {
        "ISO3": "SCG",
        "ISO-Numeric": 891,
        "fips": "YI",
        "Country": "Serbia and Montenegro",
        "Capital": "Belgrade",
        "Area(in sq km)": 102350,
        "Population": 10829175,
        "Continent": "EU",
        "tld": ".cs",
        "CurrencyCode": "RSD",
        "CurrencyName": "Dinar",
        "Phone": 381,
        "Postal Code Format": "#####",
        "Postal Code Regex": "^(\\d{5})$",
        "Languages": "cu,hu,sq,sr",
        "geonameid": 8505033,
        "neighbours": "AL,HU,MK,RO,HR,BA,BG",
        "EquivalentFipsCode": ""
    },
    "AN": {
        "ISO3": "ANT",
        "ISO-Numeric": 530,
        "fips": "NT",
        "Country": "Netherlands Antilles",
        "Capital": "Willemstad",
        "Area(in sq km)": 960,
        "Population": 300000,
        "Continent": "NA",
        "tld": ".an",
        "CurrencyCode": "ANG",
        "CurrencyName": "Guilder",
        "Phone": 599,
        "Postal Code Format": "",
        "Postal Code Regex": "",
        "Languages": "nl-AN,en,es",
        "geonameid": 8505032,
        "neighbours": "GP",
        "EquivalentFipsCode": ""
    }
}



// WEBPACK FOOTER //
// ./src/js/country-info.js